import React, { useRef, useState, useEffect } from "react";
import OdrApi from "Service/Odr.api";
import { toast } from "react-toastify";
import {
  initializeChatHub,
  joinChatRoom,
  sendMessage,
  onReceiveMessage,
  deleteMessage,
  onMessageDeleted,
  offMessageDeleted,
  leaveChatRoom,
  onReceiveSOS,
  sendSOSAlert,
  markAsRead,
  onReceiveReadReceipt,
  offReceiveReadReceipt,
  onReceiveCallInvite,
  offReceiveCallInvite,
  onReceiveCallEnded,
  offReceiveCallEnded,
  onReceiveCallAnswered,
  offReceiveCallAnswered,
  onReceiveCallRejected,
  offReceiveCallRejected,
  onReceivePstnFallbackAttempted,
  offReceivePstnFallbackAttempted,
  onCallParticipantsUpdated,
  offCallParticipantsUpdated,
  onUserPresenceChanged,
  offUserPresenceChanged,
  onUserTyping,
  offUserTyping,
  sendTypingStatus,
  getConnectionState,
} from "../../../../../Service/signalRService";
import { useNotifications } from "Components/Notification/NotificationContext";
import {
  Box,
  Avatar,
  Typography,
  IconButton,
  InputBase,
  Paper,
  Button,
  Modal,
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  InputAdornment,
  DialogActions,
  alpha,
  Stack,
  CircularProgress,
  Tooltip,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  Skeleton,
  FormControlLabel,
  Checkbox,
  Chip
} from "@mui/material";
import {
  MoreVert,
  AttachFile,
  Mic,
  Send,
  DeleteForeverRounded,
  CurrencyRupee,
  Campaign,
  Call,
  Videocam,
  Draw as DrawIcon,
  Receipt as ReceiptIcon,
  CheckCircle,
  Close,
  AccessTime,
  Done,
  DoneAll,
  People,
  InfoOutlined,
  Group
} from "@mui/icons-material";
import { CaseListType } from "DataTypes/Case.type";
import { UserInitialStateType } from "DataTypes/Redux";
import { useSelector } from "react-redux";
import { SingleMessageType } from "DataTypes/Chat.type";
import ImgPath from "Constants/Imgs";
import ChatApi from "Service/Chat.api";
import notificationApi from "Service/Notification.api";
import AdminApi from "Service/Admin.api";
import { msgFormatter } from "./Formatter";
import NoData from "Components/NoData";
import dayjs from "dayjs";
import { parseISTDate } from "Utils/Common";
import AudioComponent from "./AudioComponent";
import AttachmentComponent from "./AttachmentComponent";
import { MeetingApi } from "Service/Meeting.api";
import CaseApi from "Service/Case.api";
import { useDispatch } from "react-redux";
import {
  setAlertData,
  startLoading,
  stopLoading,
} from "../../../../../Redux/Screen/Action";
import { FormDataType } from "DataTypes/Form";
import { MeetingCreationFormArr } from "./Data";
import { commonFormSwitch, ControlledBoxSizeSwitch } from "Utils/SwitchCases";
import { HandleFormChange, MAX_FILE_SIZE_BYTES, MAX_FILE_SIZE_MB, ValidateFormData, formatUserType } from "Utils/Common";
import StatusUpdateModal from "Components/StatusUpdateModal";
import OdrStatusUpdateModal from "Components/StatusUpdateModal/OdrStatusUpdateModal";
import StatusApi from "Service/Status.api";
import ReportIcon from "@mui/icons-material/Report";

import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import PaymentApi from "Service/Payment.api";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import { useSearchParams } from "react-router-dom";
import AgoraCall from "Components/Conference/AgoraCall";
import { parseMessageWithLinks } from "Utils/LinkSecurity";
export interface SingleChatPropType {
  selectedCase: CaseListType | null;
}

// Outside the component or as a ref to prevent re-creation
const sosSound = new Audio("/Assets/audio/siren.mp3");
const ringtoneSound = new Audio("/Assets/audio/skype_call.mp3"); // Using skype call tone as requested

// parseISTDate (Utils/Common.tsx) always treats a timestamp's raw digits as literal IST wall-clock
// time — it strips any "Z"/UTC marker and re-appends "+05:30" regardless. So an optimistic/pending
// message's timestamp needs to actually BE real IST digits, not `dayjs().format(...)` (the
// browser's own local timezone, which is only IST by coincidence) and never `new Date().toISOString()`
// (real UTC digits, which parseISTDate then misreads as IST and renders ~5:30 off — every time, on
// every browser, not just a device-timezone edge case). Computing true IST via Intl avoids both.
const getISTNowString = (): string => {
  const parts = new Intl.DateTimeFormat("en-US", {
    timeZone: "Asia/Kolkata",
    year: "numeric", month: "2-digit", day: "2-digit",
    hour: "2-digit", minute: "2-digit", second: "2-digit",
    hour12: false,
  }).formatToParts(new Date());
  const get = (type: string) => parts.find((p) => p.type === type)?.value || "00";
  const hour = String(parseInt(get("hour"), 10) % 24).padStart(2, "0");
  return `${get("year")}-${get("month")}-${get("day")}T${hour}:${get("minute")}:${get("second")}`;
};

const SingleChatScreen1 = (props: SingleChatPropType) => {
  const { myInfo }: UserInitialStateType = useSelector(
    (state: any) => state?.user
  );
  const dispatch = useDispatch();
  const { selectedCase } = props;
  const [input, setInput] = useState("");
  const [openModal, setOpenMoadal] = useState(false);
  const [openStatusModal, setOpenStatusModal] = useState(false);
  const [openOdrStatusModal, setOpenOdrStatusModal] = useState(false);
  const [messages, setMessages] = useState<SingleMessageType[]>([]);
  const [isLoadingMessages, setIsLoadingMessages] = useState<boolean>(true);
  const [searchParams, setSearchParams] = useSearchParams();
  const tabParam = searchParams.get("tab") as any;
  const initialTab = tabParam && ["joint", "claimant_caucus", "respondent_caucus"].includes(tabParam) ? tabParam : "joint";
  const [activeTab, setActiveTab] = useState<"joint" | "claimant_caucus" | "respondent_caucus">(initialTab);
  const [tabUnreadCounts, setTabUnreadCounts] = useState<{
    joint: number;
    claimant_caucus: number;
    respondent_caucus: number;
  }>({ joint: 0, claimant_caucus: 0, respondent_caucus: 0 });

  const activeTabRef = useRef(activeTab);
  useEffect(() => {
    activeTabRef.current = activeTab;
    setTabUnreadCounts((prev) => ({ ...prev, [activeTab]: 0 }));
  }, [activeTab]);

  useEffect(() => {
    if (tabParam && ["joint", "claimant_caucus", "respondent_caucus"].includes(tabParam)) {
      setActiveTab(tabParam);
    }
  }, [tabParam]);

  const [hasAccess, setHasAccess] = useState<boolean | null>(null);
  const [accessMessage, setAccessMessage] = useState<string>("");
  const [fullCaseData, setFullCaseData] = useState<any>(null);

  useEffect(() => {
    if (selectedCase?.caseId) {
      setIsLoadingMessages(true);
      setMessages([]);
      setHasAccess(null);
    }
  }, [selectedCase?.caseId]);

  const orderTypeStr = (
    selectedCase?.orderType ||
    (selectedCase as any)?.orderTypeName ||
    fullCaseData?.orderTypeName ||
    fullCaseData?.orderType ||
    ""
  ).toLowerCase();

  const isMediation = orderTypeStr.includes("mediation");
  const caseClientId = Number(selectedCase?.clientId || fullCaseData?.clientId);
  const myUserId = Number(myInfo?.id);

  const isClaimant = Boolean(myUserId && caseClientId && myUserId === caseClientId);
  const userTypeUpper = (myInfo?.userType || "").toUpperCase();
  const isNeutral = userTypeUpper === "PROFESSIONAL";
  const isAdmin = userTypeUpper === "ADMIN" || userTypeUpper === "SUPERADMIN";
  const isRespondent = !isClaimant && !isNeutral && !isAdmin;

  const isOdrCase =
    orderTypeStr.includes("mediation") ||
    orderTypeStr.includes("arbitration") ||
    orderTypeStr.includes("negotiation");

  const [odrStatusInput, setOdrStatusInput] = useState("");
  const [odrStatusSubmitting, setOdrStatusSubmitting] = useState(false);

  const filteredMessages = (messages || []).filter((msg) => {
    if (!isMediation) return true;
    const type = (msg.messageType || "").trim().toLowerCase();
    if (activeTab === "joint") {
      return !type.endsWith(":claimant_caucus") && !type.endsWith(":respondent_caucus");
    }
    if (activeTab === "claimant_caucus") {
      return type.endsWith(":claimant_caucus");
    }
    if (activeTab === "respondent_caucus") {
      return type.endsWith(":respondent_caucus");
    }
    return true;
  });
  const [formData, setFormData] = useState<FormDataType[]>([]);
  const [selectedDocument, setSelectedDocument] = useState<{
    url: string | null;
    docType: "video" | "image" | null;
  }>({
    url: null,
    docType: null,
  });
  const [mediaRecorder, setMediaRecorder] = useState<MediaRecorder | null>(
    null
  );
  const [recordingChunks, setRecordingChunks] = useState<Blob[]>([]);
  const [recordedAudioUrl, setRecordedAudioUrl] = useState<string | null>(null);
  const [isRecording, setIsRecording] = useState(false);
  const [eSignModalOpen, setESignModalOpen] = useState(false);
  const [eStampModalOpen, setEStampModalOpen] = useState(false);
  const [eSignFile, setESignFile] = useState<File | null>(null);
  const [eStampFile, setEStampFile] = useState<File | null>(null);
  const [eStampState, setEStampState] = useState("");
  const [stampStates, setStampStates] = useState<any[]>([]);
  const [actionLoading, setActionLoading] = useState(false);
  const [agoraCallData, setAgoraCallData] = useState<{
    open: boolean;
    appId: string;
    channelName: string;
    token: string;
    uid: number;
    messageId?: number;
    participants: any[];
    isVideoCall?: boolean;
  }>({
    open: false,
    appId: "",
    channelName: "",
    token: "",
    uid: 0,
    participants: [],
    isVideoCall: false,
  });
  const { globalCallData } = useNotifications() || {};
  const [analyserNode, setAnalyserNode] = useState<AnalyserNode | null>(null);
  const caseId = selectedCase?.caseId;
  const [roomParticipants, setRoomParticipants] = useState<any[]>([]);

  // --- Realtime Typing & Presence States ---
  const [isParticipantTyping, setIsParticipantTyping] = useState(false);
  const [typingUserName, setTypingUserName] = useState("");
  const [isParticipantOnline, setIsParticipantOnline] = useState(false);
  const [participantLastSeen, setParticipantLastSeen] = useState<string | null>(null);
  const [onlineUserIds, setOnlineUserIds] = useState<Set<number>>(new Set());
  const [groupInfoModalOpen, setGroupInfoModalOpen] = useState(false);
  const typingTimeoutRef = useRef<any>(null);
  // AUTO-CANCEL UNANSWERED CALL (2026-08-27, 30s): mirrors the same feature added to the mobile
  // app — before this, an outgoing 1:1 call this device placed had no time limit at all; if the
  // other side never answered, the caller's "Calling..." bubble stayed open forever unless
  // someone manually cancelled. Matches WhatsApp: the caller gives up after a fixed window and
  // the call becomes a real "Missed call"/"No answer" (see the missed-call work earlier this
  // session), not a stuck UI. Client-side only (not a backend job) — same known tradeoff as
  // mobile: if this tab/device is closed mid-ring, the timer won't fire, but the existing manual
  // Cancel Call button and the other side's own actions still cover that case.
  // outgoingCallMessageIdRef tracks WHICH call the pending timeout is for, so a stale timer from
  // a previous call attempt can never fire against a new one.
  const outgoingCallTimeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const outgoingCallMessageIdRef = useRef<string | number | null>(null);
  // The 6 call-lifecycle SignalR handlers below are defined inside the initializeChatHub(token)
  // .then(...) callback in the main effect (a nested async closure), but this effect's own
  // cleanup — a sibling of that .then() call, not nested inside it — needs the SAME function
  // references to correctly unsubscribe via the multi-subscriber helpers (see signalRService.ts).
  // A ref bridges that closure boundary without having to hoist ~150 lines of handler bodies out
  // of the .then() callback.
  const callEventHandlersRef = useRef<{ [key: string]: ((data: any) => void) | undefined }>({});
  const clearOutgoingCallTimeout = () => {
    if (outgoingCallTimeoutRef.current) {
      clearTimeout(outgoingCallTimeoutRef.current);
      outgoingCallTimeoutRef.current = null;
    }
    outgoingCallMessageIdRef.current = null;
  };

  useEffect(() => {
    const handlePresence = (dataOrEvent: any) => {
      const data = dataOrEvent?.detail || dataOrEvent;
      if (!data) return;
      const targetUserId = Number(data.UserId || data.userId || 0);
      const isOnline = Boolean(data.IsOnline || data.isOnline);
      if (targetUserId) {
        setOnlineUserIds(prev => {
          const updated = new Set(prev);
          if (isOnline) updated.add(targetUserId);
          else updated.delete(targetUserId);
          return updated;
        });
      }
      const myId = Number(myInfo?.id || 0);
      if (targetUserId && targetUserId !== myId) {
        setIsParticipantOnline(isOnline);
        if (data.LastSeen || data.lastSeen) {
          setParticipantLastSeen(new Date(data.LastSeen || data.lastSeen).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }));
        }
      }
    };

    const handleTyping = (dataOrEvent: any) => {
      const data = dataOrEvent?.detail || dataOrEvent;
      if (!data) return;
      const targetCaseId = Number(data.CaseId || data.caseId || 0);
      const targetUserId = Number(data.UserId || data.userId || 0);
      const myId = Number(myInfo?.id || 0);

      if (targetCaseId === Number(caseId) && targetUserId !== myId) {
        const typing = Boolean(data.IsTyping ?? data.isTyping);
        setIsParticipantTyping(typing);
        if (data.UserName || data.userName) setTypingUserName(data.UserName || data.userName);
        if (typingTimeoutRef.current) clearTimeout(typingTimeoutRef.current);
        if (typing) {
          typingTimeoutRef.current = setTimeout(() => setIsParticipantTyping(false), 3500);
        }
      }
    };

    window.addEventListener("UserPresenceChanged", handlePresence);
    window.addEventListener("UserTyping", handleTyping);
    onUserPresenceChanged(handlePresence);
    onUserTyping(handleTyping);

    return () => {
      window.removeEventListener("UserPresenceChanged", handlePresence);
      window.removeEventListener("UserTyping", handleTyping);
      offUserPresenceChanged();
      offUserTyping();
    };
  }, [caseId, myInfo?.id]);

  // --- Fetch Room Participants ---
  useEffect(() => {
    if (caseId && hasAccess === true) {
      ChatApi.getCaseParticipants({ caseId: Number(caseId) })
        .then((res: any) => {
          if (res?.success && Array.isArray(res?.participants)) {
            setRoomParticipants(res.participants);
            const onlineIds = new Set<number>();
            res.participants.forEach((p: any) => {
              if (p.isOnline) onlineIds.add(Number(p.id));
            });
            setOnlineUserIds(prev => new Set([...Array.from(prev), ...Array.from(onlineIds)]));
          }
        })
        .catch((err: any) => {
          console.error("Failed to fetch room participants", err);
        });
    }
  }, [caseId, hasAccess]);

  // --- Sync Read Status ---
  useEffect(() => {
    if (caseId && hasAccess === true && myInfo?.id) {
      const numericCaseId = Number(caseId);
      const numericUserId = Number(myInfo.id);

      // 1. Mark Messages as Read (REST API)
      ChatApi.markMessagesAsRead({ caseId: numericCaseId })
        .then(() => {
          window.dispatchEvent(new CustomEvent("messagesMarkedRead", { detail: { caseId: numericCaseId } }));
        })
        .catch((error: any) => {
          console.error("Failed to mark messages as read", error);
        });

      // 2. Mark Messages as Read (SignalR Real-time Hub for Redis & DB flags)
      markAsRead(numericCaseId, numericUserId);

      // 3. Update LocalStorage (for Topbar Badge)
      const saved = localStorage.getItem("unread_notifications");
      if (saved) {
        try {
          const parsed = JSON.parse(saved);
          const updated = parsed.filter((n: any) => Number(n.caseId) !== numericCaseId);
          localStorage.setItem("unread_notifications", JSON.stringify(updated));
          window.dispatchEvent(new Event("notificationsUpdated"));
        } catch (e) {
          console.error("Error updating local notifications", e);
        }
      }

      // Cleanup when switching away from this chat room
      return () => {
        markAsRead(numericCaseId, numericUserId);
        ChatApi.markMessagesAsRead({ caseId: numericCaseId }).catch(() => { });
      };
    }
  }, [caseId, hasAccess, myInfo?.id]);
  const senderUserId = myInfo?.id;
  const [connStatus, setConnStatus] = useState<"connected" | "reconnecting" | "disconnected">(getConnectionState());
  useEffect(() => {
    // Debounce: a brief blip that self-heals in under ~1.2s never shows a banner at all — only a
    // sustained drop does. "Connected" always applies immediately so the banner clears the instant
    // it recovers, it just doesn't appear immediately on the way down.
    let pendingTimer: ReturnType<typeof setTimeout> | null = null;
    const handler = (e: Event) => {
      const nextState = (e as CustomEvent).detail as "connected" | "reconnecting" | "disconnected";
      if (pendingTimer) {
        clearTimeout(pendingTimer);
        pendingTimer = null;
      }
      if (nextState === "connected") {
        setConnStatus("connected");
      } else {
        pendingTimer = setTimeout(() => setConnStatus(nextState), 1200);
      }
    };
    window.addEventListener("ChatConnectionStateChanged", handler);
    return () => {
      window.removeEventListener("ChatConnectionStateChanged", handler);
      if (pendingTimer) clearTimeout(pendingTimer);
    };
  }, []);
  const canvasRef = useRef<HTMLCanvasElement | null>(null);
  const [caseStatus, setCaseStatus] = useState<any[]>([])
  const scrollRef = React.useRef<HTMLDivElement | null>(null);
  const isInitialLoadRef = useRef(true);
  const isPrependingRef = useRef(false);
  const fetchCooldownRef = useRef(false);
  const previousScrollHeightRef = useRef(0);
  const previousScrollTopRef = useRef(0);
  const isNearBottomRef = useRef(true);
  // 1. Add these states at the top of your component
  const [paymentModalOpen, setPaymentModalOpen] = useState(false);
  const [amount, setAmount] = useState("");
  const [baseAmount, setBaseAmount] = useState("");
  const [targetParty, setTargetParty] = useState("Claimant");
  const [isGeneratingLink, setIsGeneratingLink] = useState(false);
  const [isCompleted, setIsCompleted] = useState(false);

  useEffect(() => {
    if (selectedCase?.currentProcessingStatusName) {
      StatusApi.getFinalStatuses().then((res: any) => {
        const finalStatuses = Array.isArray(res?.data) ? res.data : (res?.data?.data || []);
        const normalized = finalStatuses.map((s: string) => s.trim().toLowerCase());
        if (normalized.includes(selectedCase.currentProcessingStatusName.trim().toLowerCase())) {
          setIsCompleted(true);
        } else {
          setIsCompleted(false);
        }
      }).catch(() => setIsCompleted(false));
    }
  }, [selectedCase?.currentProcessingStatusName]);

  const { setActiveCaseId, markCaseNotificationsAsRead } = useNotifications();

  // Synchronize active case with NotificationContext to auto-read incoming messages
  useEffect(() => {
    if (caseId && setActiveCaseId) {
      const numericCaseId = Number(caseId);
      setActiveCaseId(numericCaseId);

      // Also mark existing ones as read immediately
      if (markCaseNotificationsAsRead) {
        markCaseNotificationsAsRead(numericCaseId);
      }
    }
    return () => {
      if (setActiveCaseId) setActiveCaseId(null);
    };
  }, [caseId, setActiveCaseId, markCaseNotificationsAsRead]);

  useEffect(() => {
    if (caseId) {
      CaseApi.fetchCaseById({ caseId: Number(caseId) }).then((res: any) => {
        if (res?.success && res?.data) {
          const caseData = res.data;
          setFullCaseData(caseData);
          const isOdr = ["Online Mediation", "Online Arbitration", "Arbitration", "Online Negotiation"].includes(caseData.orderTypeName);

          const isClaimantUser = caseData.clientId === myInfo?.id;
          const isNeutralUser = myInfo?.userType === "PROFESSIONAL";
          const isAdminUser = myInfo?.userType === "ADMIN" || myInfo?.userType === "SUPERADMIN";
          const isRespondentUser =
            (myInfo?.email && caseData.respondentEmail && myInfo.email.trim().toLowerCase() === caseData.respondentEmail.trim().toLowerCase()) ||
            (myInfo?.phone && caseData.respondentPhone && myInfo.phone.trim().replace(/\D/g, '').endsWith(caseData.respondentPhone.trim().replace(/\D/g, ''))) ||
            (!isClaimantUser && !isNeutralUser && !isAdminUser);

          const respondentConsentUpper = (caseData.respondentConsentStatus || "").trim().toUpperCase();
          if (isOdr && isRespondentUser && respondentConsentUpper !== "ACCEPTED" && respondentConsentUpper !== "GIVEN" && respondentConsentUpper !== "CONFIRMED") {
            setHasAccess(false);
            if (caseData.respondentConsentStatus === "Rejected" || caseData.respondentConsentStatus === "Declined") {
              setAccessMessage("Access Restricted: You have rejected the case invitation.");
            } else {
              setAccessMessage("Access Restricted: You must accept the case consent before entering the chat room.");
            }
            return;
          }

          if (isOdr && myInfo?.userType === "PROFESSIONAL") {
            const matchedProf = caseData.assignedProfessionals?.find((p: any) => Number(p.professionalId) === Number(myInfo?.id));
            const isNeutralUser = Number(caseData.assignedProfessionalId) === Number(myInfo?.id);

            if (matchedProf) {
              if (matchedProf.consentStatus !== "Confirmed" && matchedProf.consentStatus !== "Accepted" && matchedProf.consentStatus !== "GIVEN") {
                setHasAccess(false);
                if (matchedProf.consentStatus === "Rejected" || matchedProf.consentStatus === "Declined") {
                  setAccessMessage("Access Restricted: You have rejected the case assignment.");
                } else {
                  setAccessMessage("Access Restricted: You must accept the case assignment and provide a conflict disclosure before entering the chat room.");
                }
                return;
              }
            } else if (isNeutralUser) {
              if (caseData.neutralConsentStatus !== "Confirmed" && caseData.neutralConsentStatus !== "Accepted" && caseData.neutralConsentStatus !== "GIVEN") {
                setHasAccess(false);
                if (caseData.neutralConsentStatus === "Rejected" || caseData.neutralConsentStatus === "Declined") {
                  setAccessMessage("Access Restricted: You have rejected the case assignment.");
                } else {
                  setAccessMessage("Access Restricted: You must accept the case assignment and provide a conflict disclosure before entering the chat room.");
                }
                return;
              }
            }
          }
          setHasAccess(true);
        }
      }).catch(() => setHasAccess(true));
    }
  }, [caseId, myInfo]);

  // Inside SingleChatScreen1 component



  useEffect(() => {
    if (!caseId || !senderUserId || hasAccess !== true) return;
    const token = localStorage.getItem("token") || "";

    if (caseId) {
      // 1. Get existing notifications from localStorage
      const saved = localStorage.getItem("unread_notifications");
      if (saved) {
        const notifications = JSON.parse(saved);

        // 2. Filter out any notifications matching the current caseId
        const filtered = notifications.filter((n: any) => n.caseId !== Number(caseId));

        // 3. Save back to localStorage
        localStorage.setItem("unread_notifications", JSON.stringify(filtered));

        // 4. Dispatch a custom event to tell the Topbar to refresh its state
        window.dispatchEvent(new Event("notificationsUpdated"));
      }
    }

    // 1. Initialize/Ensure connection is active
    initializeChatHub(token).then(() => {
      // 2. Join the specific case room
      joinChatRoom(caseId.toString());

      // Mark messages & notifications as read immediately upon entering room
      markAsRead(Number(caseId), Number(senderUserId));
      if (markCaseNotificationsAsRead) {
        markCaseNotificationsAsRead(Number(caseId));
      }

      // 3. Listen for regular messages
      onReceiveMessage((message) => {
        const incomingCaseId = message?.caseId ?? message?.CaseId;
        if (incomingCaseId && Number(incomingCaseId) !== Number(caseId)) return;

        const formattedMsg = msgFormatter(message);

        setMessages((prev: any) => {
          // 1. Deduplicate based on PkChatMessage (for real messages)
          const exists = prev.some((m: any) =>
            m.pkChatMessage && Number(m.pkChatMessage) === Number(formattedMsg.pkChatMessage)
          );
          if (exists) return prev;

          // 2. Remove any matching optimistic upload bubble for this file.
          // When we upload a file, we add a temp bubble with isUploading=true and no pkChatMessage.
          // When SignalR delivers the real message, we must remove the temp bubble to avoid duplicates.
          const baseType = (formattedMsg.messageType || '').split(':')[0];
          const isFileMsg = baseType === 'file' || baseType === 'image' || baseType === 'audio';
          let filtered = prev;
          if (isFileMsg) {
            filtered = prev.filter((m: any) => {
              if (m.isUploading !== true) return true;
              if (!formattedMsg.fileName || !m.fileName) return false;
              const origNameClean = (m.fileName || '').split('.')[0].toLowerCase();
              const incNameClean = (formattedMsg.fileName || '').split('.')[0].toLowerCase();
              const isMatch = m.fileName === formattedMsg.fileName ||
                incNameClean.includes(origNameClean) ||
                origNameClean.includes(incNameClean) ||
                (m.messageType || '').split(':')[0] === baseType;
              return !isMatch;
            });
          } else {
            // Remove the matching optimistic text bubble (isPending=true, no pkChatMessage yet)
            // now that the real server-confirmed message for it has arrived via SignalR.
            filtered = prev.filter((m: any) => {
              if (!m.isPending) return true;
              const sameSender = Number(m.senderUserId) === Number(formattedMsg.senderUserId);
              const sameContent = m.messageContent === formattedMsg.messageContent;
              return !(sameSender && sameContent);
            });
          }

          return [...filtered, formattedMsg];

        });


        // Increment tab unread count if not the active tab and not sent by me
        const mType = (message?.messageType ?? message?.MessageType ?? "").trim().toLowerCase();
        let msgTab: "joint" | "claimant_caucus" | "respondent_caucus" = "joint";
        if (mType.endsWith(":claimant_caucus")) msgTab = "claimant_caucus";
        else if (mType.endsWith(":respondent_caucus")) msgTab = "respondent_caucus";

        const senderId = message?.senderUserId ?? message?.SenderUserId;
        if (senderId && myInfo?.id && Number(senderId) !== Number(myInfo.id)) {
          if (msgTab !== activeTabRef.current) {
            setTabUnreadCounts(prev => ({
              ...prev,
              [msgTab]: prev[msgTab] + 1
            }));
          }
        }

        // --- NEW: Clear notifications immediately for this case since chat is open ---
        const saved = localStorage.getItem("unread_notifications");
        if (saved) {
          const notifications = JSON.parse(saved);
          const filtered = notifications.filter((n: any) => Number(n.caseId) !== Number(caseId));
          localStorage.setItem("unread_notifications", JSON.stringify(filtered));
          window.dispatchEvent(new Event("notificationsUpdated"));
        }

        // --- Mark as Read immediately if we are looking at the active chat screen ---
        if (caseId && myInfo?.id) {
          markAsRead(Number(caseId), Number(myInfo.id));
          ChatApi.markMessagesAsRead({ caseId: Number(caseId) }).then(() => {
            window.dispatchEvent(new CustomEvent("messagesMarkedRead", { detail: { caseId: Number(caseId) } }));
          }).catch(() => { });
        }
      });

      // 4. Listen for Read Receipts (Real-time update of checks)
      onReceiveReadReceipt((data) => {
        if (Number(data.CaseId) === Number(caseId)) {
          setMessages((prevMessages) => {
            return prevMessages.map(msg => {
              // Update flags if they aren't already true
              const updated = { ...msg };
              if (data.IsUserRead) updated.isUserRead = true;
              if (data.IsProfessionalRead) updated.isProfessionalRead = true;
              if (data.IsAdminRead) updated.isAdminRead = true;
              if (data.IsCorporateRead) updated.isCorporateRead = true;
              return updated;
            });
          });
        }
      });

      // 4.1. Listen for Call Participants Update
      // Named (not inline) so the exact same function reference can be passed to
      // offCallParticipantsUpdated in this effect's cleanup — the multi-subscriber SignalR
      // helpers key removal off the handler reference, not just the event name, so that
      // unmounting this screen never accidentally removes a DIFFERENT still-mounted
      // subscriber's listener for the same event (see signalRService.ts's BUG FIX comment).
      const handleCallParticipantsUpdated = (data: any) => {
        const payloadCaseId = data?.CaseId ?? data?.caseId;
        if (Number(payloadCaseId) === Number(caseId)) {
          const msgId = data?.MessageId ?? data?.messageId;
          const connUserIds = data?.ConnectedUserIds ?? data?.connectedUserIds;
          const targetUserIds = data?.TargetUserIds ?? data?.targetUserIds;
          const isGroupCall = data?.IsGroupCall ?? data?.isGroupCall;
          const isFull = data?.IsFull ?? data?.isFull;

          // Someone besides this device actually joined — the call was answered, so the 30s
          // auto-cancel timer (if this is that call) must not fire and wrongly end an active,
          // connected call. Same "anyone else connected" check the backend uses to decide
          // missed vs. completed.
          if (
            msgId &&
            outgoingCallMessageIdRef.current &&
            String(msgId) === String(outgoingCallMessageIdRef.current)
          ) {
            const connectedIds = String(connUserIds || '').split(',').filter(Boolean);
            const othersConnected = connectedIds.some(id => Number(id) !== Number(myInfo?.id));
            if (othersConnected) {
              clearOutgoingCallTimeout();
            }
          }

          setMessages((prevMessages: any[]) => {
            return prevMessages.map(msg => {
              if (Number(msg.pkChatMessage) === Number(msgId)) {
                return {
                  ...msg,
                  connectedUserIds: connUserIds,
                  targetUserIds: targetUserIds,
                  isGroupCall: isGroupCall,
                  isCallFull: isFull
                };
              }
              return msg;
            });
          });
        }
      };
      onCallParticipantsUpdated(handleCallParticipantsUpdated);
      callEventHandlersRef.current.callParticipantsUpdated = handleCallParticipantsUpdated;

      // 4. Listen for SOS specifically within this room (optional,
      // since Topbar also handles the global alert)
      // onReceiveSOS((data) => {
      //   const sosSystemMsg = {
      //     messageContent: "🚨 SOS: Admin assistance has been requested.",
      //     senderUserId: 0,
      //     messageType: "text",
      //     timestamp: new Date().toISOString(),
      //     link: `/chat/`
      //   };
      //   setMessages((prev) => [...prev, msgFormatter(sosSystemMsg)]);
      // });

      // 5. Listen for incoming calls
      const handleCallInvite = (data: any) => {
        const initiator = data.initiatedBy || data.InitiatedBy;
        const isVideoCall = data.isVideoCall || data.IsVideoCall;

        // Play Ringtone
        ringtoneSound.play().catch(e => console.warn("Audio play failed:", e));

        dispatch(
          setAlertData({
            alertMessage: `Incoming ${isVideoCall ? "Video " : ""}Call from ${initiator}`,
            alertVariant: "info",
            openAlert: true,
          })
        );
      };
      onReceiveCallInvite(handleCallInvite);
      callEventHandlersRef.current.callInvite = handleCallInvite;

      // 6. Listen for Call Ended event
      const handleCallEndedEvent = (data: any) => {
        const mid = data.messageId || data.MessageId;
        const dur = data.duration || data.Duration;

        // Whatever ended it (manual cancel, the other side hanging up, this same 30s timer
        // having just fired) — the pending auto-cancel for this call, if any, is no longer
        // needed.
        if (!mid || String(mid) === String(outgoingCallMessageIdRef.current)) {
          clearOutgoingCallTimeout();
        }

        ringtoneSound.pause();
        ringtoneSound.currentTime = 0;

        setMessages((prev) =>
          prev.map((msg) => {
            if (Number(msg.pkChatMessage) === Number(mid)) {
              return {
                ...msg,
                isCallEnded: true,
                callDuration: dur,
                // "Missed" here is the same sentinel the backend now sends instead of a raw
                // "00:00" duration when nobody besides the caller ever joined — see
                // EndAgoraCall's wasMissed logic. The in-thread bubble itself (callTitleText
                // above, in the message renderer) is what shows the direction-aware
                // "No answer" / "Missed call from X" text; this messageContent is only the
                // generic fallback used by list previews / notifications.
                messageContent: dur === "Missed" ? "📞 Missed call" : dur === "Cancelled" ? "📞 Call cancelled" : `📞 Call ended. Duration: ${dur}`
              };
            }
            return msg;
          })
        );

        // Auto-close modal if this specific call ended
        setAgoraCallData(prev => {
          if (prev.open && Number(prev.messageId) === Number(mid)) {
            return { ...prev, open: false };
          }
          return prev;
        });
      };
      onReceiveCallEnded(handleCallEndedEvent);
      callEventHandlersRef.current.callEnded = handleCallEndedEvent;

      // 6.1. Listen for Call Answered event — broadcast to Clients.User(id), i.e. only this
      // same user's own other connections/tabs, when one of them joins the call. Stops this
      // tab's ringtone if it was ringing too (e.g. the user answered on mobile instead).
      const handleCallAnsweredEvent = (data: any) => {
        ringtoneSound.pause();
        ringtoneSound.currentTime = 0;
      };
      onReceiveCallAnswered(handleCallAnsweredEvent);
      callEventHandlersRef.current.callAnswered = handleCallAnsweredEvent;

      // 7. Listen for Call Rejected event
      const handleCallRejectedEvent = (data: any) => {
        const rejector = data.rejectedByName || data.RejectedByName || "Participant";
        const mid = data.messageId || data.MessageId;

        if (mid && String(mid) === String(outgoingCallMessageIdRef.current)) {
          clearOutgoingCallTimeout();
        }

        dispatch(
          setAlertData({
            alertMessage: `❌ Call Declined by ${rejector}`,
            alertVariant: "error",
            openAlert: true,
          })
        );

        ringtoneSound.pause();
        ringtoneSound.currentTime = 0;

        if (mid) {
          setMessages((prev) =>
            prev.map((msg) => {
              if (Number(msg.pkChatMessage) === Number(mid)) {
                return {
                  ...msg,
                  isCallEnded: true,
                  callDuration: "Rejected",
                  messageContent: `📞 Call declined by ${rejector}`
                };
              }
              return msg;
            })
          );
        }

        setAgoraCallData((prev) => {
          if (prev.open) {
            return { ...prev, open: false };
          }
          return prev;
        });
      };
      onReceiveCallRejected(handleCallRejectedEvent);
      callEventHandlersRef.current.callRejected = handleCallRejectedEvent;

      // 7.1. PSTN fallback (BonVoice) resolved — only ever fires for a v1-eligible (non-group,
      // single-target) call whose callee never joined Agora within the server-side fallback
      // window. `success` means the phone was DIALED, not that anyone answered — see
      // PstnFallbackHostedService on the backend. The bubble's actual text logic lives in the
      // message renderer (callTitleText); this just records the flag on the matching message.
      const handlePstnFallbackAttemptedEvent = (data: any) => {
        const mid = data.chatMessageId ?? data.ChatMessageId;
        const success = data.success ?? data.Success;
        if (!mid) return;

        setMessages((prev) =>
          prev.map((msg) =>
            Number(msg.pkChatMessage) === Number(mid)
              ? { ...msg, pstnDialSuccess: !!success }
              : msg
          )
        );
      };
      onReceivePstnFallbackAttempted(handlePstnFallbackAttemptedEvent);
      callEventHandlersRef.current.pstnFallbackAttempted = handlePstnFallbackAttemptedEvent;

      // 8. Listen for Message Deleted event
      onMessageDeleted((data) => {
        const deletedId = typeof data === "object" ? (data.messageId || data.MessageId) : data;
        if (deletedId) {
          setMessages((prev) =>
            prev.map((m) => {
              if (Number(m.pkChatMessage || m.id) === Number(deletedId)) {
                return {
                  ...m,
                  isDeleted: true,
                  messageContent: "🚫 This message was deleted",
                  attachmentUrl: "",
                  fileName: "",
                };
              }
              return m;
            })
          );
        }
      });
    });

    handleFetchChatHistory();
    handleInitialLoad();

    return () => {
      leaveChatRoom(caseId.toString());
      offReceiveReadReceipt();
      if (callEventHandlersRef.current.callParticipantsUpdated) offCallParticipantsUpdated(callEventHandlersRef.current.callParticipantsUpdated);
      if (callEventHandlersRef.current.callInvite) offReceiveCallInvite(callEventHandlersRef.current.callInvite);
      if (callEventHandlersRef.current.callEnded) offReceiveCallEnded(callEventHandlersRef.current.callEnded);
      if (callEventHandlersRef.current.callAnswered) offReceiveCallAnswered(callEventHandlersRef.current.callAnswered);
      if (callEventHandlersRef.current.callRejected) offReceiveCallRejected(callEventHandlersRef.current.callRejected);
      if (callEventHandlersRef.current.pstnFallbackAttempted) offReceivePstnFallbackAttempted(callEventHandlersRef.current.pstnFallbackAttempted);
      callEventHandlersRef.current = {};
      offMessageDeleted();
      clearOutgoingCallTimeout();
    };
  }, [caseId, senderUserId, hasAccess]);

  const isWithin15Mins = (timestamp?: string) => {
    if (!timestamp) return false;
    const msgTime = parseISTDate(timestamp);
    return Math.abs(dayjs().diff(msgTime, "minute")) <= 15;
  };

  const [deleteTarget, setDeleteTarget] = useState<{ id: number; timestamp?: string } | null>(null);

  const confirmDeleteSingleMessage = async () => {
    if (!deleteTarget) return;
    const { id: numericId, timestamp } = deleteTarget;
    setDeleteTarget(null);

    const isAdmin = myInfo?.userType === "ADMIN" || myInfo?.userType === "SUPERADMIN";
    if (!isAdmin && timestamp && !isWithin15Mins(timestamp)) {
      toast.error("Messages can only be deleted within 15 minutes of sending.");
      return;
    }

    try {
      await deleteMessage(numericId, Number(caseId));
      setMessages((prev) =>
        prev.map((m) => {
          if (Number(m.pkChatMessage || m.id) === numericId) {
            return {
              ...m,
              isDeleted: true,
              messageContent: "🚫 This message was deleted",
              attachmentUrl: "",
              fileName: "",
            };
          }
          return m;
        })
      );
      toast.success("Message deleted");
    } catch (err: any) {
      console.error("Failed to delete message:", err);
      toast.error(err?.message || "Failed to delete message");
    }
  };

  // 2. SMART SCROLL MANAGEMENT (WHATSAPP STYLE): PRESERVE SCROLL POSITION ON UPWARD PREPEND
  React.useLayoutEffect(() => {
    if (!scrollRef.current) return;

    if (isInitialLoadRef.current) {
      scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
      isInitialLoadRef.current = false;
    } else if (isPrependingRef.current) {
      // Preserve the user's reading position: the new scroll height grew by however much older
      // content got prepended above them, so shift scrollTop by that same delta from where they
      // actually were (not from 0 — they could've triggered this anywhere in the "near top" band).
      const newScrollHeight = scrollRef.current.scrollHeight;
      const heightDelta = newScrollHeight - previousScrollHeightRef.current;
      scrollRef.current.scrollTop = previousScrollTopRef.current + heightDelta;
      isPrependingRef.current = false;
    } else if (isNearBottomRef.current) {
      scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
    }
  }, [filteredMessages, activeTab]);

  const handleSOSRequest = async () => {
    if (!caseId || !senderUserId) return;
    try {
      await sendSOSAlert(caseId.toString(), senderUserId);
      dispatch(setAlertData({
        alertMessage: "SOS Sent! Admins have been notified.",
        alertVariant: "success",
        openAlert: true,
      }));
    } catch (err) {
      console.error("SOS failed", err);
    }
  };

  const handleDeleteChat = async () => {
    if (!caseId) return;
    if (!window.confirm("Are you sure you want to delete this case? This action cannot be undone.")) {
      return;
    }

    try {
      dispatch(startLoading({ loading: true, loadtext: "Deleting case..." }));
      const res = await AdminApi.deleteCase(Number(caseId));
      if (res && res.success) {
        dispatch(setAlertData({
          alertMessage: "Case deleted successfully!",
          alertVariant: "success",
          openAlert: true,
        }));
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      } else {
        dispatch(setAlertData({
          alertMessage: res?.message || "Failed to delete case.",
          alertVariant: "error",
          openAlert: true,
        }));
      }
    } catch (error: any) {
      console.error("Error deleting case:", error);
      dispatch(setAlertData({
        alertMessage: error.response?.data || "An error occurred while deleting case.",
        alertVariant: "error",
        openAlert: true,
      }));
    } finally {
      dispatch(stopLoading());
    }
  };

  const handleInitialLoad = async () => {
    const newArr: FormDataType[] = JSON.parse(
      JSON.stringify(MeetingCreationFormArr)
    );
    newArr[0].value =
      newArr[4].value = ` Meeting for ${selectedCase?.orderType} - ${selectedCase?.caseNumber ? selectedCase.caseNumber : selectedCase?.caseId} - ${selectedCase?.caseType}`; // Default topic and agenda
    newArr[3].value = "30"; // Default duration
    setFormData(newArr);
  };

  useEffect(() => {
    if (!analyserNode || !canvasRef.current) return;

    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    if (!ctx) return;

    const bufferLength = analyserNode.frequencyBinCount;
    const dataArray = new Uint8Array(bufferLength);

    const draw = () => {
      if (!isRecording) return;

      analyserNode.getByteTimeDomainData(dataArray);
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.beginPath();

      for (let i = 0; i < bufferLength; i++) {
        const x = (i / bufferLength) * canvas.width;
        const y = (dataArray[i] / 128.0) * (canvas.height / 2);
        ctx.lineTo(x, y);
      }

      ctx.strokeStyle = "red";
      ctx.stroke();
      requestAnimationFrame(draw);
    };

    draw();
  }, [analyserNode, isRecording]);

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === "Escape")
        setSelectedDocument({
          docType: null,
          url: null,
        });
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, []);

  const [isLoadingOlder, setIsLoadingOlder] = useState(false);
  const [hasMoreMessages, setHasMoreMessages] = useState(true);
  const isLoadingOlderRef = useRef(false);
  const hasMoreMessagesRef = useRef(true);

  const handleFetchChatHistory: () => void = async () => {
    setIsLoadingMessages(true);
    isInitialLoadRef.current = true;
    try {
      const res = await ChatApi.fetchChatHistoryByCaseId({ caseId: caseId, limit: 30 });
      if (res?.success) {
        if (Array.isArray(res.data) && res.data.length < 30) {
          hasMoreMessagesRef.current = false;
          setHasMoreMessages(false);
        } else {
          hasMoreMessagesRef.current = true;
          setHasMoreMessages(true);
        }

        let formatteRes: SingleMessageType[] = res?.data?.map((el: any) => {
          return msgFormatter(el);
        });
        if (myInfo.userType === "ADMIN") {
          // Only "audio" needs stripping here — it renders via <AudioComponent> before the
          // "🔒 Attachment hidden for Admin" check further down, so it must never reach state.
          // "file" is safe to keep: that same check already renders it hidden identically to
          // "image" — dropping "file" here just made those messages vanish entirely for admin
          // instead of showing the hidden placeholder (confirmed via a real DB row, 2026-09-03:
          // a message sent through the document picker as messageType="file" was silently absent
          // for the admin viewer, mirroring the same bug in the mobile app's SingleChatScreen.tsx).
          formatteRes = formatteRes.filter((el) => el.messageType !== "audio");
        }

        // Compute unread counts per tab
        const counts = { joint: 0, claimant_caucus: 0, respondent_caucus: 0 };
        if (Array.isArray(res.data)) {
          res.data.forEach((el: any) => {
            const senderId = el.senderUserId ?? el.SenderUserId;
            if (senderId && myInfo?.id && Number(senderId) === Number(myInfo.id)) return;

            let isUnread = false;
            const uType = myInfo?.userType;
            if (isClaimant) {
              isUnread = uType === "CORPORATEUSER" ? !(el.isCorporateRead ?? el.IsCorporateRead) : !(el.isUserRead ?? el.IsUserRead);
            } else if (isRespondent) {
              isUnread = !(el.isRespondentRead ?? el.IsRespondentRead);
            } else if (isNeutral) {
              isUnread = !(el.isProfessionalRead ?? el.IsProfessionalRead);
            } else if (isAdmin) {
              isUnread = !(el.isAdminRead ?? el.IsAdminRead);
            }

            if (isUnread) {
              const mType = (el.messageType ?? el.MessageType ?? "").trim().toLowerCase();
              let msgTab: "joint" | "claimant_caucus" | "respondent_caucus" = "joint";
              if (mType.endsWith(":claimant_caucus")) msgTab = "claimant_caucus";
              else if (mType.endsWith(":respondent_caucus")) msgTab = "respondent_caucus";

              if (msgTab !== activeTabRef.current) {
                counts[msgTab]++;
              }
            }
          });
        }
        setTabUnreadCounts(counts);

        setMessages(formatteRes);
        if (res?.data?.[0]?.caseTypeId) {
          StatusApi.caseStatus(res?.data?.[0]?.caseTypeId)
            .then((status: any) => setCaseStatus(status?.data))
            .catch(() => { });
        }
      }
    } catch (err) {
      console.error("Failed to fetch chat history", err);
    } finally {
      setIsLoadingMessages(false);
    }
  };

  const paginationBeforeIdRef = useRef<number | null>(null);

  const handleFetchOlderMessages = async () => {
    if (isLoadingOlderRef.current || fetchCooldownRef.current || !hasMoreMessagesRef.current || messages.length === 0) return;
    const validMsgs = messages.filter(m => m.pkChatMessage && !isNaN(Number(m.pkChatMessage)) && Number(m.pkChatMessage) > 0);
    if (validMsgs.length === 0) return;
    const oldestId = Math.min(...validMsgs.map(m => Number(m.pkChatMessage)));
    if (!oldestId || isNaN(oldestId)) return;

    const beforeIdToUse = paginationBeforeIdRef.current || oldestId;

    if (scrollRef.current) {
      previousScrollHeightRef.current = scrollRef.current.scrollHeight;
      previousScrollTopRef.current = scrollRef.current.scrollTop;
      isPrependingRef.current = true;
    }

    isLoadingOlderRef.current = true;
    fetchCooldownRef.current = true;
    setIsLoadingOlder(true);
    try {
      const res = await ChatApi.fetchChatHistoryByCaseId({ caseId: caseId, beforeId: beforeIdToUse, limit: 30 });
      if (res?.success && Array.isArray(res.data)) {
        if (res.data.length < 30) {
          hasMoreMessagesRef.current = false;
          setHasMoreMessages(false);
        }

        let minId = beforeIdToUse;
        res.data.forEach((msg: any) => {
          const id = msg.pkChatMessage || msg.id;
          if (id && Number(id) < minId) {
            minId = Number(id);
          }
        });
        paginationBeforeIdRef.current = minId;

        let olderFormatted: SingleMessageType[] = res.data.map((el: any) => msgFormatter(el));
        if (myInfo.userType === "ADMIN") {
          // See the identical filter's comment further up this file — only "audio" needs stripping.
          olderFormatted = olderFormatted.filter((el) => el.messageType !== "audio");
        }

        setMessages((prev: any[]) => {
          const existingIds = new Set(prev.map(m => Number(m.pkChatMessage)).filter(id => id > 0));
          const newOlder = olderFormatted.filter(m => !m.pkChatMessage || !existingIds.has(Number(m.pkChatMessage)));
          const combined = [...newOlder, ...prev];
          return combined.sort((a, b) => (Number(a.pkChatMessage) || 0) - (Number(b.pkChatMessage) || 0));
        });
      }
    } catch (err) {
      console.error("Failed to fetch older chat history", err);
    } finally {
      isLoadingOlderRef.current = false;
      setIsLoadingOlder(false);
      setTimeout(() => {
        fetchCooldownRef.current = false;
      }, 500);
    }
  };

  const handleSend = async () => {
    if (!caseId || !senderUserId) return;
    isNearBottomRef.current = true;

    // If there's a recorded audio ready to be sent
    if (recordedAudioUrl && recordingChunks.length) {
      const blob = new Blob(recordingChunks, { type: "audio/webm" });
      const res = await ChatApi.handleUploadVoice({
        audioBlob: blob,
        caseId,
        senderUserId,
      });

      if (res?.success && res?.data?.url) {
        const typeSuffix = activeTab === "claimant_caucus" ? ":claimant_caucus" : activeTab === "respondent_caucus" ? ":respondent_caucus" : "";
        await sendMessage(
          caseId,
          senderUserId,
          "",
          "audio" + typeSuffix,
          `${process.env.REACT_APP_BASE_URL}${res.data.url}`,
          res?.data?.fileName || "voiceMessage.webm"
        );
      }

      // Cleanup after sending audio
      handleDeleteRecording();
      return;
    }

    // Otherwise, send text message
    if (input.trim()) {
      const typeSuffix = activeTab === "claimant_caucus" ? ":claimant_caucus" : activeTab === "respondent_caucus" ? ":respondent_caucus" : "";
      const text = input.trim();
      const tempId = `temp_text_${Date.now()}_${Math.random()}`;

      // Optimistic UI: show the message immediately instead of waiting for the SignalR round-trip
      // (Hub authorization + DB save) to complete. Reconciled/removed once ReceiveMessage confirms it.
      setMessages((prev: any) => [...prev, {
        id: tempId,
        senderUserId,
        messageContent: text,
        messageType: "text" + typeSuffix,
        // See getISTNowString's own comment above — must be real IST digits, not the browser's
        // local timezone and not a UTC ISO string, to match what parseISTDate expects.
        timestamp: getISTNowString(),
        isPending: true,
      }]);
      setInput("");
      isNearBottomRef.current = true;

      try {
        await sendMessage(caseId, senderUserId, text, "text" + typeSuffix, "", "");
      } catch (err) {
        console.error("Failed to send message:", err);
        setMessages((prev: any) => prev.map((m: any) => m.id === tempId ? { ...m, isPending: false, sendError: true } : m));
        toast.error("Message failed to send. Please try again.");
      }
    }
  };

  const handleEnterPress: (event: any) => void = (event) => {
    if (event?.keyCode === 13 || event?.key === "Enter") {
      if (event.shiftKey) {
        // Shift+Enter: let the default behaviour add a newline
        return;
      }
      event.preventDefault();
      handleSend();
    }
  };

  const handleStartRecording = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      const recorder = new MediaRecorder(stream);
      const chunks: Blob[] = [];
      setRecordingChunks([]);
      setRecordedAudioUrl(null);
      setMediaRecorder(recorder);
      setIsRecording(true);

      recorder.ondataavailable = (e) => {
        if (e.data.size > 0) chunks.push(e.data);
      };

      recorder.onstop = () => {
        const blob = new Blob(chunks, { type: "audio/webm" });
        const url = URL.createObjectURL(blob);
        setRecordingChunks(chunks);
        setRecordedAudioUrl(url);
        setIsRecording(false);
      };

      // Setup AnalyserNode for waveform
      const audioContext = new AudioContext();
      const source = audioContext.createMediaStreamSource(stream);
      const analyser = audioContext.createAnalyser();
      source.connect(analyser);
      setAnalyserNode(analyser);

      recorder.start();
    } catch (error) {
      console.error("Recording failed", error);
    }
  };

  const handleStopRecording = () => {
    if (mediaRecorder && isRecording) {
      mediaRecorder.stop();
      setIsRecording(false);
    }
  };

  const handleDeleteRecording = () => {
    setRecordedAudioUrl(null);
    setRecordingChunks([]);
    setMediaRecorder(null);
  };

  const handleAttachmentUpload = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const files = event.target.files;
    if (!files || !caseId || !senderUserId) return;

    const fileArray = Array.from(files);

    try {
      const BLOCKED_EXTENSIONS = [".exe", ".apk", ".bat", ".cmd", ".sh", ".php", ".js", ".vbs", ".ps1", ".msi", ".dll", ".scr", ".jar", ".html", ".htm", ".pif", ".com", ".iso", ".zip"];
      const ALLOWED_EXTENSIONS = [".jpg", ".jpeg", ".png", ".gif", ".heic", ".heif", ".webp", ".pdf", ".doc", ".docx", ".xls", ".xlsx", ".txt", ".csv", ".mp4", ".webm", ".mov", ".mp3", ".wav", ".m4a"];

      const invalidFiles = fileArray.filter((file) => {
        const ext = file.name.substring(file.name.lastIndexOf(".")).toLowerCase();
        return BLOCKED_EXTENSIONS.includes(ext) || !ALLOWED_EXTENSIONS.includes(ext);
      });

      if (invalidFiles.length > 0) {
        const names = invalidFiles.map((f) => f.name).join(", ");
        dispatch(
          setAlertData({
            alertMessage: `Invalid file format for: ${names}. Executable files (.exe, .apk, etc.) are strictly prohibited.`,
            alertVariant: "error",
            openAlert: true,
          })
        );
        return;
      }

      const oversizedFiles = fileArray.filter(f => f.size > MAX_FILE_SIZE_BYTES);

      if (oversizedFiles.length > 0) {
        const names = oversizedFiles.map(f => f.name).join(", ");
        dispatch(
          setAlertData({
            alertMessage: `The following files are too large: ${names}. The maximum size is ${MAX_FILE_SIZE_MB}MB.`,
            alertVariant: "error",
            openAlert: true,
          })
        );
        return;
      }

      // WhatsApp-style: create a temporary optimistic upload bubble for each file
      const typeSuffix = activeTab === "claimant_caucus" ? ":claimant_caucus" : activeTab === "respondent_caucus" ? ":respondent_caucus" : "";

      const uploadPromises = fileArray.map(async (file) => {
        // 1. Show an immediate "Uploading…" bubble in the chat
        const tempId = `temp_upload_${Date.now()}_${Math.random()}`;
        const localPreviewUrl = URL.createObjectURL(file);
        const tempMsg: any = {
          pkChatMessage: null,
          id: tempId,
          messageContent: "",
          messageType: "file" + typeSuffix,
          attachmentUrl: localPreviewUrl,
          fileName: file.name,
          senderUserId: senderUserId,
          senderUser: null,
          // See getISTNowString's own comment near the top of this file — a real UTC ISO string
          // here gets misread as literal IST by parseISTDate and renders ~5:30 behind, on every
          // browser, every time (confirmed bug, not just a device-timezone edge case).
          timestamp: getISTNowString(),
          isUploading: true,
          uploadError: false,
        };
        isNearBottomRef.current = true;
        setMessages((prev: any) => [...prev, tempMsg]);

        try {
          // 2. Upload the file
          const res = await ChatApi.uploadAttachment({
            attachmentBlob: file,
            caseId: caseId,
          });

          if (res?.success && res?.data?.url) {
            const fullUrl = `${process.env.REACT_APP_BASE_URL}${res.data.url}`;
            const finalFileName = res?.data?.fileName || file.name;

            // 3. Send via SignalR (the real message server-side)
            await sendMessage(
              caseId,
              senderUserId,
              "",
              "file" + typeSuffix,
              fullUrl,
              finalFileName
            );

            // 4. Update optimistic bubble: replace local URL with real CDN URL, mark done
            setMessages((prev: any[]) =>
              prev.map((m: any) =>
                m.id === tempId
                  ? { ...m, attachmentUrl: fullUrl, fileName: finalFileName, isUploading: false }
                  : m
              )
            );
          } else {
            // 5. Mark as error
            setMessages((prev: any[]) =>
              prev.map((m: any) =>
                m.id === tempId ? { ...m, isUploading: false, uploadError: true } : m
              )
            );
            dispatch(
              setAlertData({
                alertMessage: res?.message || `Failed to upload ${file.name}.`,
                alertVariant: "error",
                openAlert: true,
              })
            );
          }
        } catch (err) {
          console.error("Attachment upload failed for", file.name, err);
          setMessages((prev: any[]) =>
            prev.map((m: any) =>
              m.id === tempId ? { ...m, isUploading: false, uploadError: true } : m
            )
          );
        } finally {
          // Revoke object URL to free memory after a short delay
          setTimeout(() => URL.revokeObjectURL(localPreviewUrl), 5000);
        }
      });

      await Promise.all(uploadPromises);
    } catch (err) {
      console.error("One or more attachment uploads failed", err);
    } finally {
      // Clear input so user can select the same files again if needed
      event.target.value = "";
    }
  };



  const downloadImage = async (url: string, fileName: string) => {
    try {
      let targetFileName = fileName || "image.jpg";

      // If the file stored on server is WebP or JPEG, update targetFileName extension if it was .heic
      if (url.match(/\.webp$/i)) {
        targetFileName = targetFileName.replace(/\.(heic|heif)$/i, ".webp");
      } else if (url.match(/\.(jpg|jpeg|png)$/i)) {
        targetFileName = targetFileName.replace(/\.(heic|heif)$/i, ".jpg");
      }

      const response = await fetch(url, {
        mode: "cors",
        cache: "no-cache",
      });

      if (!response.ok) {
        throw new Error("Failed to fetch file.");
      }

      let blob = await response.blob();

      // Only attempt heic2any if target URL is truly an un-converted HEIC file
      if ((url.match(/\.(heic|heif)$/i) || blob.type.includes("heic") || blob.type.includes("heif")) && !url.match(/\.(webp|jpg|jpeg|png)$/i)) {
        try {
          const heic2any = (await import("heic2any")).default;
          const converted = await heic2any({
            blob,
            toType: "image/jpeg",
            quality: 0.9,
          });
          blob = Array.isArray(converted) ? converted[0] : converted;
          targetFileName = targetFileName.replace(/\.(heic|heif)$/i, ".jpg");
        } catch (heicErr) {
          console.warn("Client side heic2any conversion fallback:", heicErr);
        }
      }

      const blobUrl = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = blobUrl;
      link.setAttribute("download", targetFileName);
      document.body.appendChild(link);
      link.click();

      // Cleanup
      link.parentNode?.removeChild(link);
      URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error("Fetch download failed, attempting direct link download:", error);
      try {
        const link = document.createElement("a");
        link.href = url;
        link.target = "_blank";
        link.setAttribute("download", fileName || "download");
        document.body.appendChild(link);
        link.click();
        link.parentNode?.removeChild(link);
      } catch (fallbackErr) {
        window.open(url, "_blank");
      }
    }
  };


  const handleCloseCase = async () => {
    if (isOdrCase) {
      setOpenOdrStatusModal(true);
    } else {
      setOpenStatusModal(true);
    }
  };

  const handleReOpenCase = async () => { };

  const handleStatusUpdate = async (selectedStatus: any) => {
    try {
      dispatch(startLoading({ loading: true, loadtext: "Updating Status..." }));

      // Here you would call your API to update the case status
      // const res = await CaseApi.updateCaseStatus({
      //   caseId: selectedCase?.caseId,
      //   statusId: selectedStatus.pkProcessingStatus
      // });

      // Send a message to the chat about the status update
      if (selectedCase?.caseId && senderUserId) {
        await sendMessage(
          selectedCase.caseId,
          senderUserId,
          `Case status updated to: ${selectedStatus.statusName}.`,
          "text",
          "",
          ""
        );
      }

      dispatch(
        setAlertData({
          alertMessage: `Case status updated to ${selectedStatus.statusName}`,
          alertVariant: "success",
          openAlert: true,
        })
      );

      dispatch(stopLoading());
    } catch (error) {
      dispatch(stopLoading());
      dispatch(
        setAlertData({
          alertMessage: "Failed to update case status",
          alertVariant: "error",
          openAlert: true,
        })
      );
    }
  };
  const handleCallConnection = async (isJoinOnly: boolean = false, isVideoCall: boolean = false, targetUserIds?: number[], isGroupCallParam?: boolean) => {
    ringtoneSound.pause();
    ringtoneSound.currentTime = 0;
    dispatch(startLoading({ loading: true, loadtext: isJoinOnly ? "Joining Call..." : "Connecting Call..." }));

    const caucusType = activeTab === "claimant_caucus" ? "claimant_caucus" : activeTab === "respondent_caucus" ? "respondent_caucus" : null;

    const res = await MeetingApi.AgoraConferenceCall({
      caseId: selectedCase?.caseId?.toString(),
      isJoinOnly: isJoinOnly,
      isVideoCall: isVideoCall,
      isGroupCall: isGroupCallParam ?? isGroupCall,
      caucusType: caucusType,
      targetUserIds: targetUserIds
    });
    console.log("res", res);
    if (res?.success) {
      dispatch(stopLoading());
      const payload = res.data || res;
      const actualIsVideo = payload.isVideoCall ?? isVideoCall;
      setAgoraCallData({
        open: true,
        appId: payload.appId || res.appId,
        channelName: payload.channelName || res.channelName,
        token: payload.token || res.token,
        uid: Number(payload.uid || res.uid),
        messageId: payload.messageId || res.messageId,
        participants: payload.participants || res.participants || [],
        isVideoCall: actualIsVideo,
      });

      // AUTO-CANCEL UNANSWERED CALL — see the ref declarations above for the full rationale.
      // Only for a fresh 1:1 outgoing call THIS tab is placing (isJoinOnly=false, not a group
      // call) — joining an existing call, or a group call where other invitees may still pick
      // up later, must never auto-cancel.
      const effectiveIsGroupCall = isGroupCallParam ?? isGroupCall;
      const outgoingMessageId = payload.messageId || res.messageId;
      if (!isJoinOnly && !effectiveIsGroupCall && outgoingMessageId) {
        clearOutgoingCallTimeout();
        outgoingCallMessageIdRef.current = outgoingMessageId;
        outgoingCallTimeoutRef.current = setTimeout(async () => {
          outgoingCallTimeoutRef.current = null;
          try {
            // BUG FIX (2026-09-04): this timer is only ever cleared by a CallParticipantsUpdated
            // SignalR event confirming the other party joined — if that single event is ever
            // missed (a brief reconnect gap, dropped message), this used to blindly end an
            // ACTUALLY-ANSWERED, ongoing call with a hardcoded duration:"00:00", stamping a real
            // 30-40 minute conversation as a missed call. One last authoritative server check
            // before taking the destructive action closes that race without needing the SignalR
            // event to be perfectly reliable.
            const status = await MeetingApi.GetCallStatus(caseId).catch(() => null);
            const statusMessageId = status?.messageId ?? status?.MessageId;
            const isSameCall = statusMessageId == null || Number(statusMessageId) === Number(outgoingMessageId);
            const connIds = String(status?.connectedUserIds ?? status?.ConnectedUserIds ?? '').split(',').filter(Boolean);
            const othersConnected = isSameCall && connIds.some((id) => Number(id) !== Number(myInfo?.id));
            const alreadyEnded = isSameCall && (status?.isCallEnded ?? status?.IsCallEnded);
            if (othersConnected || alreadyEnded) {
              return;
            }
            await MeetingApi.EndAgoraConferenceCall({
              messageId: outgoingMessageId,
              duration: "00:00"
            });
          } catch (e) {
            console.error("Failed to auto-cancel unanswered call", e);
          }
        }, 30000);
      }
    } else {
      dispatch(stopLoading());
      const alertMsg = res?.message || res?.alert?.alertMessage || res?.data?.message || (res?.isCallFull ? "This call is a private 1-to-1 call and already has 2 active participants." : "Failed to initiate call.");
      dispatch(
        setAlertData({
          alertMessage: alertMsg,
          alertVariant: "error",
          openAlert: true,
        })
      );
    }
  };

  const [callModalOpen, setCallModalOpen] = useState(false);
  const [callIsVideo, setCallIsVideo] = useState(false);
  const [selectedCallUserIds, setSelectedCallUserIds] = useState<number[]>([]);
  const [isGroupCall, setIsGroupCall] = useState(false);

  const openCallModal = (isVideo: boolean) => {
    setCallIsVideo(isVideo);
    setIsGroupCall(false);
    const participants = getCallParticipantsList();
    if (participants.length === 1) {
      setSelectedCallUserIds([Number(participants[0][0])]);
    } else {
      setSelectedCallUserIds([]);
    }
    setCallModalOpen(true);
  };

  const getCallParticipantsList = () => {
    const memberMap = new Map<number, string>();

    // 0. Add members from roomParticipants (backend GET /api/chat/{caseId}/participants)
    if (Array.isArray(roomParticipants)) {
      roomParticipants.forEach((p: any) => {
        const uId = Number(p.id);
        if (uId && uId !== Number(senderUserId)) {
          const pName = p.name ? `${p.name}${p.role ? ` (${p.role})` : ""}` : `Member (${uId})`;
          memberMap.set(uId, pName);
        }
      });
    }

    // 1. Add members from selectedCase
    if (selectedCase) {
      if (selectedCase.clientId && Number(selectedCase.clientId) !== Number(senderUserId)) {
        const cName = selectedCase.clientFullName ? `${selectedCase.clientFullName} (Client)` : "Client";
        memberMap.set(Number(selectedCase.clientId), cName);
      }
      if (selectedCase.assignedProfessionalId && Number(selectedCase.assignedProfessionalId) !== Number(senderUserId)) {
        const pName = selectedCase.assignedProfessionalName ? `${selectedCase.assignedProfessionalName} (Professional)` : "Professional";
        memberMap.set(Number(selectedCase.assignedProfessionalId), pName);
      }
    }

    // 2. Add members from fullCaseData
    if (fullCaseData) {
      if (fullCaseData.clientId && Number(fullCaseData.clientId) !== Number(senderUserId)) {
        const cName = fullCaseData.clientFullName ? `${fullCaseData.clientFullName} (Client)` : "Client";
        memberMap.set(Number(fullCaseData.clientId), cName);
      }
      if (fullCaseData.assignedProfessionalId && Number(fullCaseData.assignedProfessionalId) !== Number(senderUserId)) {
        const pName = fullCaseData.assignedProfessionalName ? `${fullCaseData.assignedProfessionalName} (Professional)` : "Professional";
        memberMap.set(Number(fullCaseData.assignedProfessionalId), pName);
      }
      if (Array.isArray(fullCaseData.assignedProfessionals)) {
        fullCaseData.assignedProfessionals.forEach((p: any) => {
          const pId = Number(p.professionalId || p.userId || p.id);
          if (pId && pId !== Number(senderUserId)) {
            const pName = p.name || p.fullName || p.professionalName || p.userName;
            memberMap.set(pId, pName ? `${pName} (${p.role || "Professional"})` : `Professional (${pId})`);
          }
        });
      }
    }

    // 2.1 For Admin Support chats, ensure Admin/SuperAdmin is represented
    if (selectedCase?.orderTypeId === 53 || selectedCase?.orderType === "Admin Support" || fullCaseData?.orderTypeId === 53) {
      if (selectedCase?.assignedAdminId && Number(selectedCase.assignedAdminId) !== Number(senderUserId)) {
        memberMap.set(Number(selectedCase.assignedAdminId), `${selectedCase.assignedAdminName || "Admin"} (Admin)`);
      } else if (fullCaseData?.assignedAdminId && Number(fullCaseData.assignedAdminId) !== Number(senderUserId)) {
        memberMap.set(Number(fullCaseData.assignedAdminId), `${fullCaseData.assignedAdminName || "Admin"} (Admin)`);
      } else {
        let hasAdmin = false;
        if (Array.isArray(messages)) {
          messages.forEach((m: any) => {
            if (m.senderUser?.userType === "ADMIN" || m.senderUser?.userType === "SUPERADMIN") {
              if (Number(m.senderUserId) !== Number(senderUserId)) {
                memberMap.set(Number(m.senderUserId), `${m.senderName || "Admin"} (${formatUserType(m.senderUser.userType)})`);
                hasAdmin = true;
              }
            }
          });
        }
        if (!hasAdmin && myInfo?.userType !== "ADMIN" && myInfo?.userType !== "SUPERADMIN") {
          memberMap.set(1, "Admin Support (Admin)");
        }
      }
    }

    // 3. Add members from chat messages
    if (Array.isArray(messages)) {
      messages.forEach((m: any) => {
        const uId = Number(m.senderUserId);
        if (uId && uId !== Number(senderUserId)) {
          let name = m.senderName;
          const u = m.senderUser;
          if (u) {
            const fullName = (u.fullName || `${u.firstName || ""} ${u.lastName || ""}`).trim();
            if (fullName) {
              name = `${fullName}${u.userType ? ` (${formatUserType(u.userType)})` : ""}`;
            } else if (u.userName) {
              name = u.userName;
            } else if (u.email) {
              name = u.email;
            }
          }
          if (name && !name.toLowerCase().startsWith("user ")) {
            memberMap.set(uId, name);
          } else if (!memberMap.has(uId)) {
            memberMap.set(uId, name || `Member (${uId})`);
          }
        }
      });
    }

    return Array.from(memberMap.entries());
  };

  const handleStartSelectedCall = () => {
    setCallModalOpen(false);
    const targets = isGroupCall ? undefined : selectedCallUserIds;
    handleCallConnection(false, callIsVideo, targets);
  };

  useEffect(() => {
    const autoJoin = searchParams.get("autoJoinCall");
    const isVideo = searchParams.get("isVideoCall") === "true";
    if (autoJoin === "1" && caseId && !globalCallData?.open) {
      handleCallConnection(true, isVideo);

      const newParams = new URLSearchParams(searchParams);
      newParams.delete("autoJoinCall");
      newParams.delete("isVideoCall");
      setSearchParams(newParams, { replace: true });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [caseId, searchParams, globalCallData?.open]);

  useEffect(() => {
    const handler = (e: any) => {
      if (e.detail?.caseId && String(e.detail.caseId) === String(caseId)) {
        handleCallConnection(true, e.detail?.isVideoCall);
      }
    };
    window.addEventListener('DirectWebCallJoin', handler);
    return () => window.removeEventListener('DirectWebCallJoin', handler);
  }, [caseId]);

  const handleScheduleMeet: () => void = async () => {
    dispatch(startLoading({ loading: true, loadtext: "Scheduling Meeting..." }));
    if (!caseId || !senderUserId) return;

    const validation = ValidateFormData(formData);
    setFormData(validation.formData);
    if (!validation.errorCheck && selectedCase?.caseId) {
      dispatch(
        startLoading({ loading: true, loadtext: "Scheduling Meeting..." })
      );

      const date = formData.find((el) => el.id === "startAt")?.value;
      const time = formData.find((el) => el.id === "startTime")?.value;
      const combinedDateTime = dayjs(
        `${date} ${time}`,
        "YYYY-MM-DD hh:mm A"
      ).format("YYYY-MM-DD hh:mm A");
      const payload: any = {
        caseId: selectedCase?.caseId?.toString(),
        topic: formData.find((el) => el.id === "topic")?.value,
        startAt: combinedDateTime,
        durationInMinutes: formData.find((el) => el.id === "durationInMinutes")
          ?.value,
        agenda: formData.find((el) => el.id === "agenda")?.value,
      };
      const res = await MeetingApi.ScheduleMeeting(payload);
      if (res?.success) {
        await sendMessage(
          selectedCase?.caseId,
          senderUserId ?? 0,
          `Meeting successfully scheduled at ${dayjs(payload.startAt).format(
            "YYYY-MM-DD, hh:mm A"
          )}`,
          "text",
          "",
          ""
        );
        dispatch(
          setAlertData({
            alertMessage: "Meeting scheduled successfully.",
            alertVariant: "success",
            openAlert: true,
          })
        );
        dispatch(stopLoading());
        setOpenMoadal(false);
        handleInitialLoad();
      } else {
        dispatch(stopLoading());
      }
    }
  };

  // 2. Add the submit handler
  const handleSendPaymentLink = async () => {
    if (!amount || isNaN(Number(amount))) return;

    dispatch(startLoading({ loading: true, loadtext: "Generating Payment Link..." }));

    setIsGeneratingLink(true);
    try {
      const response = await PaymentApi.generatePaymentLinkForCase({
        caseId: caseId,
        amount: Number(amount),
        targetParty: targetParty,
      });

      const paymentLink = response.data?.paymentLink || response.data?.PaymentLink;
      const paymentId = response.data?.paymentId || response.data?.PaymentId;

      // We send a specific prefix "💳 PAYMENT_REQUEST|" so the UI knows to render a button
      await sendMessage(
        caseId ?? 0,
        myInfo.id ?? 0,
        `PAYMENT_REQUEST|${amount}|${paymentLink}|${paymentId || ''}`,
        "text"
      );

      setPaymentModalOpen(false);
      setAmount("");
    } catch (error) {
      console.error("Failed to generate payment link", error);
    } finally {
      dispatch(stopLoading());
      setIsGeneratingLink(false);
    }
  };

  const modalBody = (
    <Box
      sx={{
        ...sxMain,
        backgroundColor: "common.white",
        boxShadow: "0px 0px 6px #00000029",
        borderRadius: 1.25,
        width: "50%",
      }}
    >
      {
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            ...sxHead,
            justifyContent: "space-between",
            height: "3rem",
          }}
        >
          <Typography
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-end",
              "&>svg": {
                mr: 1,
              },
            }}
          >
            Schedule Meetinng
          </Typography>
          {
            <IconButton onClick={() => setOpenMoadal(false)}>
              <ImgPath.CloseIcon />
            </IconButton>
          }
        </Box>
      }
      <Box
        sx={{
          height: "calc(100% - 6rem)",
          p: 2,
        }}
      >
        <Grid mb={2} container columnSpacing={2} rowSpacing={2}>
          {formData.map((el: FormDataType) => (
            <Grid key={el.id} size={{ ...ControlledBoxSizeSwitch(el.boxSize) }}>
              {commonFormSwitch({
                formObj: el,
                onChange: (data) =>
                  setFormData(HandleFormChange(data, formData)),
              })}
            </Grid>
          ))}
        </Grid>
      </Box>
      {
        <Box
          sx={{
            px: 2,
            mb: 2,
            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-end",
            height: "3rem",
          }}
        >
          <Button
            variant="contained"
            color="primary"
            onClick={() => handleScheduleMeet()}
          >
            Schedule
          </Button>
          <Button
            variant="outlined"
            color="secondary"
            onClick={() => setOpenMoadal(false)}
            sx={{ ml: 1, borderColor: "primary.main", color: "primary.main" }}
          >
            Cancel
          </Button>
        </Box>
      }
    </Box>
  );

  const getInitials: (orderType: string) => string = (orderType) => {
    if (!orderType) return "";
    const words = orderType.split(" ");
    let initials = "";
    for (let i = 0; i < words.length && i < 2; i++) {
      initials += words[i].charAt(0).toUpperCase();
    }
    return initials;
  };

  const handleEndCall = async (duration: string) => {
    if (!agoraCallData.messageId) return;
    try {
      await MeetingApi.EndAgoraConferenceCall({
        messageId: agoraCallData.messageId,
        duration: duration,
        // PSTN fallback (BonVoice): this is always a deliberate user action (the call modal's
        // own hang-up/close button), never the 30s auto-give-up timer — tells the backend not
        // to treat this as a genuine "nobody answered" and dial the caller's/callee's real
        // phones. Only takes effect server-side when the call turns out to have never
        // connected (wasMissed); harmless no-op otherwise.
        isManualCancel: true
      });
    } catch (e) {
      console.error("Failed to end call session", e);
    }
  };

  const handleDeclineCall = async (msgId: string, isInitiator: boolean) => {
    ringtoneSound.pause();
    ringtoneSound.currentTime = 0;

    if (!msgId) return;

    if (isInitiator) {
      // Clearing the 30s auto-cancel timer synchronously here too (not just relying on the
      // CallEnded round-trip) closes the tiny race window where it could otherwise fire a
      // second, redundant EndAgoraConferenceCall call while this one is still in flight.
      if (String(msgId) === String(outgoingCallMessageIdRef.current)) {
        clearOutgoingCallTimeout();
      }
      try {
        await MeetingApi.EndAgoraConferenceCall({
          messageId: msgId,
          duration: "00:00",
          // PSTN fallback (BonVoice): this is the caller's own explicit Cancel Call button —
          // must never be treated the same as the 30s auto-give-up timeout, or a deliberate
          // cancel would still trigger a real phone call to both parties a few seconds later.
          isManualCancel: true
        });
      } catch (e) {
        console.error("Failed to cancel call", e);
      }
    } else {
      try {
        const currentUserId = localStorage.getItem("x-nlp-userid") || (myInfo as any)?.id || "0";
        await MeetingApi.RejectAgoraConferenceCall({
          caseId: selectedCase?.caseId || 0,
          messageId: Number(msgId),
          rejectedByUserId: Number(currentUserId)
        });
      } catch (e) {
        console.error("Failed to decline call", e);
      }
    }
  };



  const handleOdrProfessionalStatusUpdate = async () => {
    if (!odrStatusInput.trim() || !selectedCase?.caseId || !senderUserId) return;
    setOdrStatusSubmitting(true);
    try {
      const statusNote = odrStatusInput.trim();

      // Hit the new backend endpoint to store the custom status using OdrApi
      const response = await OdrApi.updateOdrCustomStatus(
        selectedCase.caseId,
        { customStatus: statusNote }
      );

      if (response?.success) {
        await sendMessage(
          selectedCase.caseId,
          senderUserId,
          `[ODR STATUS UPDATE] ${statusNote}`,
          "system",
          "",
          ""
        );
        setOdrStatusInput("");
        window.location.reload();
      }
    } catch (err) {
      console.error("Failed to post ODR status update", err);
    } finally {
      setOdrStatusSubmitting(false);
    }
  };

  const fetchStampStates = async () => {
    try {
      const response = await StatusApi.getStampDetails();
      const data = response?.data;
      if (Array.isArray(data)) {
        setStampStates(data);
      } else if (data && Array.isArray(data.data)) {
        setStampStates(data.data);
      } else {
        setStampStates([]);
      }
    } catch (error) {
      console.error("Failed to fetch estamp states", error);
    }
  };

  useEffect(() => {
    if (eStampModalOpen && stampStates.length === 0) {
      fetchStampStates();
    }
  }, [eStampModalOpen]);

  const handleSendForESign = async () => {
    if (!eSignFile || !caseId) return;
    setActionLoading(true);
    const formData = new FormData();
    formData.append("CaseId", caseId.toString());
    formData.append("FileName", eSignFile.name);
    formData.append("PdfFile", eSignFile);

    try {
      const response = await StatusApi.eSignDocument(formData);
      if (response?.data?.success) {
        toast.success("Document successfully sent for E-Sign!");
        setESignModalOpen(false);
        setESignFile(null);
        await sendMessage(caseId, senderUserId ?? 0, `Document '${eSignFile.name}' was sent for E-Sign.`, "system", "", "");
      } else {
        toast.error(response?.data?.message || "Failed to send document.");
      }
    } catch (error) {
      console.error(error);
      toast.error("An error occurred while sending for E-Sign.");
    }
    setActionLoading(false);
  };

  const handleSendForEStamp = async () => {
    if (!eStampFile || !caseId || !eStampState) return;
    setActionLoading(true);
    const stateDetail = stampStates.find(s => s.stateCode === eStampState);

    const formData = new FormData();
    formData.append("CaseId", caseId.toString());
    formData.append("FileName", eStampFile.name);
    formData.append("PdfFile", eStampFile);
    formData.append("StateCode", stateDetail?.stateCode || "");
    formData.append("EstampCode", stateDetail?.stampCode || "");

    try {
      const response = await StatusApi.eStampDocument(formData);
      if (response?.data?.success) {
        toast.success("Document successfully sent for E-Stamp!");
        setEStampModalOpen(false);
        setEStampFile(null);
        setEStampState("");
        await sendMessage(caseId, senderUserId ?? 0, `Document '${eStampFile.name}' was sent for E-Stamp.`, "system", "", "");
      } else {
        toast.error(response?.data?.message || "Failed to send document.");
      }
    } catch (error) {
      console.error(error);
      toast.error("An error occurred while sending for E-Stamp.");
    }
    setActionLoading(false);
  };

  if (hasAccess === null || isLoadingMessages) {
    return (
      <Box
        sx={{
          height: "100%",
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
          backgroundColor: "#f8fafc",
        }}
      >
        {/* Header Skeleton */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            px: 3,
            py: 2,
            background: "rgba(255, 255, 255, 0.9)",
            backdropFilter: "blur(12px)",
            borderBottom: "1px solid rgba(0, 0, 0, 0.08)",
            flexShrink: 0,
          }}
        >
          <Skeleton variant="circular" width={44} height={44} animation="wave" />
          <Box sx={{ ml: 2, flexGrow: 1 }}>
            <Skeleton variant="text" width={180} height={24} animation="wave" />
            <Skeleton variant="text" width={90} height={16} animation="wave" />
          </Box>
          <Stack direction="row" spacing={1}>
            <Skeleton variant="circular" width={32} height={32} animation="wave" />
            <Skeleton variant="circular" width={32} height={32} animation="wave" />
          </Stack>
        </Box>

        {/* Main Messages Skeleton Area */}
        <Box
          sx={{
            flexGrow: 1,
            p: 3,
            display: "flex",
            flexDirection: "column",
            gap: 2.5,
            overflow: "hidden",
            justifyContent: "center",
            alignItems: "center",
            position: "relative",
            background: "linear-gradient(180deg, #f8fafc 0%, #e2e8f0 100%)",
          }}
        >
          {/* Background Skeleton Bubbles */}
          <Box sx={{ width: "100%", maxWidth: "800px", display: "flex", flexDirection: "column", gap: 2, opacity: 0.5 }}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
              <Skeleton variant="circular" width={32} height={32} animation="wave" />
              <Skeleton variant="rounded" width="45%" height={52} sx={{ borderRadius: "18px 18px 18px 4px" }} animation="wave" />
            </Box>
            <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
              <Skeleton variant="rounded" width="50%" height={60} sx={{ borderRadius: "18px 18px 4px 18px", bgcolor: "rgba(26, 35, 126, 0.1)" }} animation="wave" />
            </Box>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
              <Skeleton variant="circular" width={32} height={32} animation="wave" />
              <Skeleton variant="rounded" width="38%" height={44} sx={{ borderRadius: "18px 18px 18px 4px" }} animation="wave" />
            </Box>
          </Box>

          {/* Center Floating Glassmorphic Spinner Badge */}
          <Paper
            elevation={4}
            sx={{
              position: "absolute",
              px: 4,
              py: 3,
              borderRadius: 4,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: 2,
              background: "rgba(255, 255, 255, 0.95)",
              backdropFilter: "blur(12px)",
              border: "1px solid rgba(255, 255, 255, 0.8)",
              boxShadow: "0 12px 32px rgba(26, 35, 126, 0.12)",
            }}
          >
            <CircularProgress size={36} thickness={4.5} sx={{ color: "#1a237e" }} />
            <Box sx={{ textAlign: "center" }}>
              <Typography variant="subtitle2" sx={{ fontWeight: 800, color: "#1a237e", letterSpacing: "0.2px" }}>
                Loading Conversation...
              </Typography>
              <Typography variant="caption" sx={{ color: "text.secondary", fontWeight: 600 }}>
                Fetching case messages & securing connection
              </Typography>
            </Box>
          </Paper>
        </Box>

        {/* Input Bar Skeleton */}
        <Box sx={{ p: 2, bgcolor: "#fff", borderTop: "1px solid rgba(0,0,0,0.08)", flexShrink: 0 }}>
          <Skeleton variant="rounded" width="100%" height={48} sx={{ borderRadius: "24px" }} animation="wave" />
        </Box>
      </Box>
    );
  }

  if (hasAccess === false) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" height="100%" sx={{ p: 4, width: '100%' }}>
        <Paper elevation={3} sx={{ p: 4, borderRadius: 4, textAlign: "center", maxWidth: 400, bgcolor: "#fffbeb", border: "1px solid #f59e0b" }}>
          <ReportIcon sx={{ fontSize: 60, color: "#d97706", mb: 2 }} />
          <Typography variant="h6" sx={{ fontWeight: 700, color: "#78350f", mb: 2 }}>
            Access Restricted
          </Typography>
          <Typography variant="body1" sx={{ color: "#92400e", mb: 3 }}>
            {accessMessage}
          </Typography>
          <Button
            variant="contained"
            color="warning"
            onClick={() => window.location.href = `/odr-workspace/${caseId}`}
            sx={{ textTransform: "none", fontWeight: 700, borderRadius: "10px", bgcolor: "#d97706", "&:hover": { bgcolor: "#b45309" } }}
          >
            Go to Dispute Workspace
          </Button>
        </Paper>
      </Box>
    );
  }

  return (
    <Box sx={{ height: "100%", flex: 1, minHeight: 0, display: "flex", flexDirection: "column", overflow: "hidden", backgroundColor: "#efeae2" }}>
      {/* Modals remain at the top level */}
      <Modal open={openModal} onClose={() => setOpenMoadal(false)}>{modalBody}</Modal>
      <StatusUpdateModal
        open={openStatusModal}
        onClose={() => setOpenStatusModal(false)}
        caseStatus={caseStatus}
        onStatusUpdate={handleStatusUpdate}
        currentCaseId={selectedCase?.caseId}
        currentCaseNumber={selectedCase?.caseNumber}
      />
      <OdrStatusUpdateModal
        open={openOdrStatusModal}
        onClose={() => setOpenOdrStatusModal(false)}
        currentCaseId={selectedCase?.caseId}
        currentCaseNumber={selectedCase?.caseNumber}
        currentStatus={selectedCase?.odrStatus || selectedCase?.currentProcessingStatusName || "INITIATED"}
        onStatusUpdated={async (newStatus) => {
          if (selectedCase?.caseId && senderUserId) {
            await sendMessage(
              selectedCase.caseId,
              senderUserId,
              `ODR Case status updated to: ${newStatus}.`,
              "text",
              "",
              ""
            );
          }
          window.location.reload();
        }}
      />

      {/* VERSION 4: LIGHTWEIGHT WHITE GLASS HEADER */}
      <Box sx={{
        display: "flex",
        alignItems: "center",
        px: 3,
        py: 2,
        background: "rgba(255, 255, 255, 0.9)",
        backdropFilter: "blur(12px)",
        borderBottom: "1px solid rgba(0, 0, 0, 0.08)",
        flexShrink: 0,
        zIndex: 11,
        position: "sticky",
        top: 0,
      }}>
        <Avatar
          alt={selectedCase?.orderType}
          sx={{
            width: 44,
            height: 44,
            background: "linear-gradient(135deg, #1a237e, #3949ab)",
            color: "#fff",
            fontWeight: 800,
            fontSize: "1rem",
            boxShadow: "0 2px 8px rgba(0,0,0,0.1)"
          }}
        >
          {getInitials(selectedCase?.orderType ?? "")}
        </Avatar>
        <Box sx={{ ml: 2, flexGrow: 1, cursor: "pointer" }} onClick={() => setGroupInfoModalOpen(true)}>
          <Typography variant="subtitle1" sx={{ fontWeight: 800, color: "#1a237e", lineHeight: 1.2 }}>
            {selectedCase?.caseName
              ? selectedCase.caseName
              : ((myInfo?.userType === "ADMIN" || myInfo?.userType === "SUPERADMIN") && (selectedCase?.orderType === "Admin Support" || selectedCase?.orderTypeId === 53)
                ? (selectedCase?.clientUserType === "CORPORATEUSER"
                  ? `${selectedCase?.clientFullName || "User"} (${selectedCase?.clientOrganizationName || "N/A"})`
                  : `${selectedCase?.clientFullName || "User"} - (${formatUserType(selectedCase?.clientUserType || "USER")})`)
                : (selectedCase?.orderType || "Conversation"))}
          </Typography>
          <Typography variant="caption" sx={{ color: "text.primary", opacity: 0.7, fontWeight: 600 }}>
            {selectedCase?.caseNumber ? `#${selectedCase.caseNumber}` : `ID: ${selectedCase?.caseId}`}
          </Typography>
          {(() => {
            const myId = Number(myInfo?.id || 0);

            // Count only OTHER participants currently online in this group (excluding current user)
            const otherOnlineCount = roomParticipants.filter((p: any) => {
              const pid = Number(p.id);
              if (pid === myId) return false;
              return onlineUserIds.has(pid) || Boolean(p.isOnline);
            }).length;

            const allMemberNames = roomParticipants.map((p: any) => p.name).join(", ");

            return (
              <Typography
                variant="caption"
                sx={{
                  color: isParticipantTyping ? "#25D366" : otherOnlineCount > 0 ? "#16a34a" : "text.primary",
                  opacity: 0.9,
                  fontWeight: 700,
                  display: "block",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                  maxWidth: 500,
                }}
                title={allMemberNames ? `Members: ${allMemberNames}` : undefined}
              >
                {isParticipantTyping
                  ? `✍️ ${typingUserName || 'Participant'} is typing...`
                  : otherOnlineCount > 0
                    ? `🟢 ${otherOnlineCount} Online`
                    : (allMemberNames || 'Group Chat')}
              </Typography>
            );
          })()}
        </Box>
        <Stack direction="row" spacing={0.5}>
          {/* Group Members & Info Modal Trigger */}
          <Tooltip title="Group Members & Info">
            <IconButton size="small" sx={{ color: "#4a4c96ff" }} onClick={() => setGroupInfoModalOpen(true)}>
              <People />
            </IconButton>
          </Tooltip>
          {/* Audio and Video Call for all participants. E_MITRA_USER added 2026-09-03 — e-mitra
              agents can dial calls for cases they created, same as other participants. */}
          {["USER", "CORPORATEUSER", "NRIUSER", "PROFESSIONAL", "ADMIN", "E_MITRA_USER"].includes(myInfo?.userType?.toUpperCase()) && !(isCompleted && !isAdmin) && (
            <>
              <Tooltip title="Audio Call">
                <IconButton size="small" sx={{ color: "#4a4c96ff" }} onClick={() => openCallModal(false)}><ImgPath.CallIcon /></IconButton>
              </Tooltip>
              {/* DISABLED (2026-09-04, explicit request): Video Call button removed from the chat
                  toolbar system-wide (website + mobile) — audio calling stays untouched.
                  openCallModal(true)/the underlying video-call plumbing (AgoraCall.tsx, the
                  callIsVideo modal branch below, etc.) is left fully intact — only this entry
                  point is commented out. Re-enable by uncommenting if this is wanted again.
              <Tooltip title="Video Call">
                <IconButton size="small" sx={{ color: "#4a4c96ff" }} onClick={() => openCallModal(true)}><Videocam /></IconButton>
              </Tooltip>
              */}
            </>
          )}

          {/* Schedule Meeting — e-mitra agents included (2026-09-03): they can schedule meetings
              for cases they created, but must NOT update case status (see the separate,
              narrower block below for that) — kept as its own condition rather than folded back
              into "Case Management Tools" on purpose. */}
          {["PROFESSIONAL", "ADMIN", "E_MITRA_USER"].includes(myInfo?.userType?.toUpperCase()) && !(isCompleted && !isAdmin) && (
            <Tooltip title="Schedule Meeting">
              <IconButton size="small" sx={{ color: "#4a4c96ff" }} onClick={() => setOpenMoadal(true)}><ImgPath.CalenderIcon /></IconButton>
            </Tooltip>
          )}

          {/* Case Management Tools for Professionals & Admins only — e-mitra agents must NOT be
              able to update case status (2026-09-03 spec). */}
          {["PROFESSIONAL", "ADMIN"].includes(myInfo?.userType) && !(isCompleted && !isAdmin) && (
            <>
              <Tooltip title="Handle Case Status">
                <IconButton size="small" sx={{ color: "#4a4c96ff" }} onClick={handleCloseCase}><ImgPath.TaskAltRoundedIcon /></IconButton>
              </Tooltip>
              <Tooltip title="Reopen Case">
                <IconButton size="small" sx={{ color: "#4a4c96ff" }} onClick={handleReOpenCase}><ImgPath.ReplayRoundedIcon /></IconButton>
              </Tooltip>
            </>
          )}

          {/* Admin Billing Tools & Document Tools */}
          {["ADMIN", "SUPERADMIN"].includes(myInfo?.userType) && (
            <>
              <Tooltip title="Request Payment">
                <IconButton size="small" sx={{ color: "#4a4c96ff" }} onClick={() => setPaymentModalOpen(true)}><CurrencyRupee /></IconButton>
              </Tooltip>
              <Tooltip title="E-Sign Document">
                <IconButton size="small" sx={{ color: "#4a4c96ff" }} onClick={() => setESignModalOpen(true)}><DrawIcon /></IconButton>
              </Tooltip>
              <Tooltip title="E-Stamp Document">
                <IconButton size="small" sx={{ color: "#4a4c96ff" }} onClick={() => setEStampModalOpen(true)}><ReceiptIcon /></IconButton>
              </Tooltip>
            </>
          )}

          {/* Client SOS */}
          {["USER", "CORPORATEUSER", "NRIUSER"].includes(myInfo?.userType) && !(isCompleted && !isAdmin) && (
            <Tooltip title="Emergency SOS">
              <IconButton size="small" sx={{ color: "#4a4c96ff", backgroundColor: alpha("#fff", 0.15), "&:hover": { backgroundColor: alpha("#fff", 0.25) }, boxShadow: "0 2px 8px rgba(0,0,0,0.1)" }} onClick={handleSOSRequest}>
                <Campaign sx={{ fontSize: 20 }} />
              </IconButton>
            </Tooltip>
          )}

          {/* SuperAdmin Destructive Actions */}
          {myInfo?.userType === "SUPERADMIN" && (
            <Tooltip title="Delete Chat">
              <IconButton
                size="small"
                sx={{ color: "#d32f2f", "&:hover": { backgroundColor: "rgba(211, 47, 47, 0.08)" } }}
                onClick={handleDeleteChat}
              >
                <DeleteForeverRounded />
              </IconButton>
            </Tooltip>
          )}
        </Stack>
      </Box>

      {/* GLASSMORPHISM TABS FOR MEDIATION CAUCUSES */}
      {isMediation && (
        <Box sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          gap: 1.5,
          py: 1.5,
          px: 3,
          background: "rgba(255, 255, 255, 0.7)",
          backdropFilter: "blur(10px)",
          borderBottom: "1px solid rgba(0, 0, 0, 0.05)",
          flexShrink: 0,
          zIndex: 10
        }}>
          {/* Joint Tab */}
          <Button
            variant="text"
            onClick={() => setActiveTab("joint")}
            sx={{
              textTransform: "none",
              fontWeight: 700,
              fontFamily: "Outfit",
              borderRadius: "10px",
              px: 2.5,
              py: 0.8,
              color: activeTab === "joint" ? "#1a237e" : "text.primary",
              bgcolor: activeTab === "joint" ? "rgba(26, 35, 126, 0.08)" : "transparent",
              "&:hover": {
                bgcolor: "rgba(26, 35, 126, 0.04)"
              }
            }}
          >
            Joint Session
            {tabUnreadCounts.joint > 0 && (
              <Box sx={{
                ml: 1,
                bgcolor: "#ef4444",
                color: "white",
                borderRadius: "50%",
                width: 18,
                height: 18,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "10px",
                fontWeight: "bold"
              }}>
                {tabUnreadCounts.joint}
              </Box>
            )}
          </Button>

          {/* Claimant Caucus Tab */}
          {(isClaimant || isNeutral || isAdmin) && (
            <Button
              variant="text"
              onClick={() => setActiveTab("claimant_caucus")}
              sx={{
                textTransform: "none",
                fontWeight: 700,
                fontFamily: "Outfit",
                borderRadius: "10px",
                px: 2.5,
                py: 0.8,
                color: activeTab === "claimant_caucus" ? "#4f46e5" : "text.secondary",
                bgcolor: activeTab === "claimant_caucus" ? "rgba(79, 70, 229, 0.08)" : "transparent",
                "&:hover": {
                  bgcolor: "rgba(79, 70, 229, 0.04)"
                }
              }}
            >
              {isClaimant ? "Private Caucus (with Mediator)" : "Claimant Caucus"}
              {tabUnreadCounts.claimant_caucus > 0 && (
                <Box sx={{
                  ml: 1,
                  bgcolor: "#ef4444",
                  color: "white",
                  borderRadius: "50%",
                  width: 18,
                  height: 18,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "10px",
                  fontWeight: "bold"
                }}>
                  {tabUnreadCounts.claimant_caucus}
                </Box>
              )}
            </Button>
          )}

          {/* Respondent Caucus Tab */}
          {(isRespondent || isNeutral || isAdmin) && (
            <Button
              variant="text"
              onClick={() => setActiveTab("respondent_caucus")}
              sx={{
                textTransform: "none",
                fontWeight: 700,
                fontFamily: "Outfit",
                borderRadius: "10px",
                px: 2.5,
                py: 0.8,
                color: activeTab === "respondent_caucus" ? "#0891b2" : "text.secondary",
                bgcolor: activeTab === "respondent_caucus" ? "rgba(8, 145, 178, 0.08)" : "transparent",
                "&:hover": {
                  bgcolor: "rgba(8, 145, 178, 0.04)"
                }
              }}
            >
              {isRespondent ? "Private Caucus (with Mediator)" : "Respondent Caucus"}
              {tabUnreadCounts.respondent_caucus > 0 && (
                <Box sx={{
                  ml: 1,
                  bgcolor: "#ef4444",
                  color: "white",
                  borderRadius: "50%",
                  width: 18,
                  height: 18,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "10px",
                  fontWeight: "bold"
                }}>
                  {tabUnreadCounts.respondent_caucus}
                </Box>
              )}
            </Button>
          )}
        </Box>
      )}

      {connStatus !== "connected" && (
        <Box sx={{
          py: 0.5,
          textAlign: "center",
          fontSize: "0.75rem",
          fontWeight: 600,
          color: connStatus === "reconnecting" ? "#92400e" : "#991b1b",
          bgcolor: connStatus === "reconnecting" ? "#fef3c7" : "#fee2e2",
        }}>
          {connStatus === "reconnecting" ? "Reconnecting…" : "Disconnected — trying to reconnect"}
        </Box>
      )}

      {/* VERSION 4: LIGHTWEIGHT AZURE MESSAGE AREA */}
      <Box
        ref={scrollRef}
        onWheel={(e: React.WheelEvent<HTMLDivElement>) => {
          if (e.deltaY < 0 && scrollRef.current && scrollRef.current.scrollTop <= 50) {
            handleFetchOlderMessages();
          }
        }}
        onScroll={(e: React.UIEvent<HTMLDivElement>) => {
          const target = e.currentTarget;
          const isNearBottom = target.scrollHeight - target.scrollTop - target.clientHeight <= 120;
          isNearBottomRef.current = isNearBottom;

          if (target.scrollTop <= 50) {
            handleFetchOlderMessages();
          }
        }}
        sx={{
          flex: 1,
          minHeight: 0,
          overflowY: "auto",
          p: { xs: 1.5, sm: 2, md: 3 },
          display: "flex",
          flexDirection: "column",
          gap: 1.5,
          backgroundColor: "#f0f7ff", // Lightweight Azure
          position: "relative",
          backgroundImage: `linear-gradient(rgba(240, 247, 255, 0.95), rgba(240, 247, 255, 0.95)), url("https://user-images.githubusercontent.com/15075759/28719144-86dc0f70-73b1-11e7-911d-60d70fcded21.png")`,
          backgroundRepeat: "repeat",
          backgroundSize: "400px",
          backgroundAttachment: "fixed",
        }}>
        {hasMoreMessages && isLoadingOlder && (
          <Box sx={{ alignSelf: 'center', my: 1 }}>
            <CircularProgress size={20} color="primary" />
          </Box>
        )}
        <Box sx={{ alignSelf: 'center', my: 2 }}>
          <Typography sx={{
            fontSize: '0.75rem',
            fontWeight: 700,
            color: "text.primary",
            backgroundColor: "rgba(255,255,255,0.8)",
            backdropFilter: "blur(5px)",
            px: 3,
            py: 0.75,
            borderRadius: 5,
            boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
            border: "1px solid rgba(0,0,0,0.05)",
            opacity: 0.8
          }}>
            🔒 This conversation is secured with end-to-end encryption.
          </Typography>
        </Box>

        {(() => {
          let lastDateHeader = "";
          return filteredMessages?.length > 0 ? (
            filteredMessages.map((msg, index) => {
              const msgDate = parseISTDate(msg.timestamp);
              let currentDateLabel = "";
              if (msgDate && msgDate.isValid()) {
                const today = dayjs();
                const yesterday = dayjs().subtract(1, 'day');
                if (msgDate.isSame(today, 'day') || msgDate.isAfter(today, 'day')) {
                  currentDateLabel = "Today";
                } else if (msgDate.isSame(yesterday, 'day')) {
                  currentDateLabel = "Yesterday";
                } else {
                  currentDateLabel = msgDate.format("D MMMM YYYY");
                }
              }

              let showDateDivider = false;
              if (currentDateLabel && currentDateLabel !== lastDateHeader) {
                showDateDivider = true;
                lastDateHeader = currentDateLabel;
              }

              if (msg.messageType === "system") {
                return (
                  <React.Fragment key={msg.pkChatMessage || msg.id || index}>
                    {showDateDivider && (
                      <Box sx={{ alignSelf: 'center', my: 1.5 }}>
                        <Typography sx={{
                          fontSize: '0.72rem',
                          fontWeight: 700,
                          color: "#475569",
                          backgroundColor: "rgba(255, 255, 255, 0.92)",
                          backdropFilter: "blur(6px)",
                          px: 2,
                          py: 0.5,
                          borderRadius: 4,
                          boxShadow: "0 1px 4px rgba(0,0,0,0.08)",
                          border: "1px solid rgba(0,0,0,0.06)",
                          textTransform: "uppercase",
                          letterSpacing: "0.5px"
                        }}>
                          {currentDateLabel}
                        </Typography>
                      </Box>
                    )}
                    <Box sx={{
                      alignSelf: "center",
                      my: 1,
                      maxWidth: "85%",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                    }}>
                      <Box sx={{
                        backgroundColor: "rgba(0, 0, 0, 0.06)",
                        backdropFilter: "blur(5px)",
                        px: 2.5,
                        py: 0.75,
                        borderRadius: "12px",
                        boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
                        border: "1px solid rgba(0,0,0,0.05)",
                        textAlign: "center",
                      }}>
                        <Typography variant="body2" sx={{
                          fontSize: "0.75rem",
                          fontWeight: 700,
                          color: "text.primary",
                          opacity: 0.8,
                          lineHeight: 1.4,
                        }}>
                          {msg.messageContent}
                        </Typography>
                      </Box>
                      <Typography variant="caption" sx={{ mt: 0.5, fontSize: "0.6rem", fontWeight: 700, color: "text.primary", opacity: 0.5 }}>
                        {parseISTDate(msg.timestamp).format("hh:mm A, DD-MM-YYYY")}
                      </Typography>
                    </Box>
                  </React.Fragment>
                );
              }

              const isMe = msg.senderUserId === myInfo.id;
              const isPayment = msg.messageContent?.startsWith("PAYMENT_REQUEST|");

              // E_MITRA_USER (2026-09-03): mirrors PROFESSIONAL's existing restriction — e-mitra
              // agents must not see payment-related messages either.
              if (isPayment && (myInfo?.userType?.toUpperCase() === "PROFESSIONAL" || myInfo?.userType?.toUpperCase() === "E_MITRA_USER")) {
                return null;
              }

              let payAmount = "", payUrl = "", paymentId = "", paymentStatus = "", paidBy = "";
              if (isPayment) {
                const parts = msg.messageContent.split("|");
                payAmount = parts[1] || "";
                payUrl = parts[2] || "";
                paymentId = parts[3] || "";
                paymentStatus = parts[4] || "";
                paidBy = parts[5] || "";
              }

              const isPaid = Boolean(isPayment) && (paymentStatus.toUpperCase() === "PAID" || paymentStatus.toUpperCase() === "COMPLETED");
              const msgAgeHours = msg.timestamp ? dayjs().diff(dayjs(msg.timestamp), 'hour') : 0;
              const isExpired = Boolean(isPayment) && (paymentStatus.toUpperCase() === "EXPIRED" || (!isPaid && msgAgeHours >= 24));

              const isRead = Boolean(
                msg.isUserRead ||
                msg.isRespondentRead ||
                msg.isCorporateRead ||
                msg.isProfessionalRead ||
                msg.isAdminRead
              );
              const isDelivered = Boolean(isRead || msg.pkChatMessage || msg.id);

              return (
                <React.Fragment key={msg.pkChatMessage || msg.id || index}>
                  {showDateDivider && (
                    <Box sx={{ alignSelf: 'center', my: 1.5 }}>
                      <Typography sx={{
                        fontSize: '0.72rem',
                        fontWeight: 700,
                        color: "#475569",
                        backgroundColor: "rgba(255, 255, 255, 0.92)",
                        backdropFilter: "blur(6px)",
                        px: 2,
                        py: 0.5,
                        borderRadius: 4,
                        boxShadow: "0 1px 4px rgba(0,0,0,0.08)",
                        border: "1px solid rgba(0,0,0,0.06)",
                        textTransform: "uppercase",
                        letterSpacing: "0.5px"
                      }}>
                        {currentDateLabel}
                      </Typography>
                    </Box>
                  )}

                  <Box sx={{
                    alignSelf: isMe ? "flex-end" : "flex-start",
                    maxWidth: "75%",
                    mb: 1.5,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: isMe ? "flex-end" : "flex-start",
                    opacity: msg.isPending ? 0.6 : 1,
                    transition: "opacity 0.15s ease",
                  }}>
                    <Box sx={{
                      background: isMe && !isPayment
                        ? "linear-gradient(135deg, #1a237e 0%, #283593 100%)"
                        : (isPayment ? (isPaid ? "#f0fdf4" : (isExpired ? "#fef2f2" : "#ffffff")) : "#ffffff"),
                      color: (isMe && !isPayment) ? "#ffffff" : "text.primary",
                      px: 2,
                      py: 1.2,
                      borderRadius: isMe ? "16px 16px 4px 16px" : "16px 16px 16px 4px",
                      boxShadow: isMe ? "0 4px 12px rgba(26, 35, 126, 0.18)" : "0 2px 8px rgba(0,0,0,0.06)",
                      border: isPaid ? "1px solid #86efac" : (isExpired ? "1px solid #fca5a5" : (isMe ? "none" : "1px solid rgba(0,0,0,0.08)")),
                      position: "relative",
                      maxWidth: "100%",
                      display: "flex",
                      flexDirection: "column",
                    }}>
                      {!isMe && (
                        <Typography
                          variant="caption"
                          sx={{
                            fontWeight: 800,
                            color: "#1a237e",
                            fontSize: "0.73rem",
                            display: "block",
                            mb: 0.5,
                          }}
                        >
                          {(() => {
                            const mAny = msg as any;
                            if (mAny.senderName) return mAny.senderName;
                            if (mAny.SenderName) return mAny.SenderName;
                            const u = mAny.senderUser || mAny.SenderUser;
                            if (u) {
                              const fn = u.firstName || u.FirstName || "";
                              const ln = u.lastName || u.LastName || "";
                              const full = `${fn} ${ln}`.trim();
                              if (full) return full;
                              if (u.userName || u.UserName) return u.userName || u.UserName;
                            }
                            if (mAny.senderUserType) return formatUserType(mAny.senderUserType);
                            return "Participant";
                          })()}
                          {((msg as any).senderUserType || msg.senderUser?.userType) && (
                            <span style={{ fontWeight: 500, color: "#64748b", marginLeft: 4 }}>
                              • {formatUserType((msg as any).senderUserType || msg.senderUser?.userType)}
                            </span>
                          )}
                        </Typography>
                      )}

                      {isPayment ? (
                        <Box sx={{ minWidth: "240px" }}>
                          <Stack direction="row" alignItems="center" spacing={1} mb={1.5}>
                            <Box sx={{
                              p: 1,
                              bgcolor: isPaid ? alpha("#2e7d32", 0.15) : (isExpired ? alpha("#d32f2f", 0.15) : alpha("#1a237e", 0.1)),
                              borderRadius: 1.5
                            }}>
                              {isPaid ? (
                                <CheckCircle sx={{ color: '#2e7d32', fontSize: 20 }} />
                              ) : isExpired ? (
                                <AccessTime sx={{ color: '#d32f2f', fontSize: 20 }} />
                              ) : (
                                <CurrencyRupee sx={{ color: '#1a237e', fontSize: 20 }} />
                              )}
                            </Box>
                            <Typography variant="subtitle2" sx={{ fontWeight: 800, color: isPaid ? "#2e7d32" : (isExpired ? "#d32f2f" : "#1a237e") }}>
                              {isPaid ? "Payment Completed" : (isExpired ? "Payment Link Expired" : "Payment Request")}
                            </Typography>
                          </Stack>

                          <Typography variant="body2" sx={{ mb: (isPaid || isExpired) ? 1 : 2, color: "text.primary", fontWeight: 500 }}>
                            {isPaid ? (
                              <>
                                Payment of <b style={{ color: "#2e7d32", fontSize: '1rem' }}>₹{payAmount}</b> was successfully paid by <b style={{ color: "#1a237e" }}>{paidBy || "Client"}</b>.
                              </>
                            ) : isExpired ? (
                              <>
                                The payment link of <b style={{ color: "#d32f2f", fontSize: '1rem' }}>₹{payAmount}</b> has expired (24h limit).
                              </>
                            ) : (
                              <>
                                The professional has requested a payment of <b style={{ color: "#1a237e", fontSize: '1rem' }}>₹{payAmount}</b>
                              </>
                            )}
                          </Typography>

                          {isPaid ? (
                            <Box sx={{
                              pt: 1,
                              mt: 1,
                              borderTop: "1px solid rgba(46,125,50,0.2)",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between"
                            }}>
                              <Typography variant="caption" sx={{ fontWeight: 700, color: "#2e7d32", display: "flex", alignItems: "center", gap: 0.5 }}>
                                <CheckCircle sx={{ fontSize: 16 }} /> Paid by {paidBy || "Client"}
                              </Typography>
                            </Box>
                          ) : isExpired ? (
                            <Box sx={{
                              pt: 1,
                              mt: 1,
                              borderTop: "1px solid rgba(211,47,47,0.2)",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center"
                            }}>
                              <Typography variant="caption" sx={{ fontWeight: 700, color: "#d32f2f", display: "flex", alignItems: "center", gap: 0.5 }}>
                                <AccessTime sx={{ fontSize: 16 }} /> Link Expired
                              </Typography>
                            </Box>
                          ) : !isMe ? (
                            <Button
                              variant="contained"
                              size="large"
                              fullWidth
                              href={payUrl}
                              target="_blank"
                              sx={{
                                background: "linear-gradient(90deg, #1a237e, #283593)",
                                color: "white",
                                borderRadius: 2,
                                textTransform: 'none',
                                fontWeight: 700,
                                boxShadow: "0 4px 12px rgba(26, 35, 126, 0.2)"
                              }}
                            >
                              Complete Payment
                            </Button>
                          ) : (
                            <Box sx={{ pt: 1, borderTop: "1px solid rgba(0,0,0,0.05)", textAlign: 'right' }}>
                              <Typography variant="caption" sx={{ fontWeight: 700, color: "#1a237e", cursor: 'pointer' }} onClick={() => window.open(payUrl, '_blank')}>View Receipt Link →</Typography>
                            </Box>
                          )}
                        </Box>
                      ) : (
                        <>
                          {msg.isDeleted || msg.messageContent === "🚫 This message was deleted" ? (
                            <Typography
                              variant="body2"
                              component="span"
                              sx={{
                                fontStyle: "italic",
                                color: msg.senderUserId === myInfo.id ? "rgba(255,255,255,0.75)" : "text.secondary",
                                display: "flex",
                                alignItems: "center",
                                gap: 0.5,
                                fontWeight: 500,
                              }}
                            >
                              🚫 This message was deleted
                            </Typography>
                          ) : msg.messageType?.startsWith("audio") ? <AudioComponent message={msg} /> :
                            msg.messageType?.startsWith("call") ? (() => {
                              console.log(msg, 'msg')
                              const isGroupCallMsg = (msg.messageType || "").includes(":group") || msg.isGroupCall === true || (msg.messageContent || "").toLowerCase().includes("group");
                              const senderIdNum = Number(msg.senderUserId);
                              const myIdNum = Number(myInfo?.id);
                              const isSender = Boolean(myInfo?.id && msg.senderUserId && myIdNum === senderIdNum);
                              const u = (msg as any).senderUser || (msg as any).SenderUser;
                              const fn = u?.firstName || u?.FirstName || "";
                              const ln = u?.lastName || u?.LastName || "";
                              const senderUserFullName = `${fn} ${ln}`.trim() || u?.userName || u?.UserName || "";
                              const callerName = (msg.senderName && msg.senderName.trim()) || (msg as any).SenderName || senderUserFullName || "Caller";

                              const targetIdsStr = msg.targetUserIds || "";
                              const targetIds = String(targetIdsStr)
                                .split(',')
                                .map(id => parseInt(id.trim(), 10))
                                .filter(id => !isNaN(id) && id > 0 && id !== senderIdNum);

                              let receiverName = (msg as any).targetUserNames || (msg as any).TargetUserNames || (msg as any).targetUserName || (msg as any).TargetUserName || (msg as any).receiverName || (msg as any).ReceiverName || "";

                              if (!receiverName) {
                                const pList = getCallParticipantsList();
                                const pMap = new Map(pList);
                                if (targetIds.length > 0) {
                                  const matchedNames = targetIds.map(id => pMap.get(id)).filter(Boolean);
                                  if (matchedNames.length > 0) {
                                    receiverName = matchedNames.join(", ");
                                  }
                                }
                              }
                              if (!receiverName) {
                                receiverName = "Participant";
                              }

                              const displayCallerName = callerName.replace(/\s*\((Client|Professional|Admin|SuperAdmin|Member|\d+)\)/gi, "").trim() || callerName;
                              const displayReceiverName = receiverName.replace(/\s*\((Client|Professional|Admin|SuperAdmin|Member|\d+)\)/gi, "").trim() || receiverName;

                              const isTargeted = isGroupCallMsg
                                ? true
                                : targetIdsStr
                                  ? targetIdsStr.includes(`,${myIdNum},`)
                                  : true;

                              const connIdsStr = msg.connectedUserIds || "";
                              const connUserList = connIdsStr.split(',').filter(Boolean);
                              const activeCount = connUserList.length > 0 ? connUserList.length : 1;
                              const isCallFull = !isGroupCallMsg && (msg.isCallFull === true || activeCount >= 2);

                              let callTitleText = "";
                              if (msg.isCallEnded) {
                                // MISSED CALL / DECLINED (2026-08-27): callDuration carries a
                                // sentinel string ("Missed"/"Rejected") instead of an elapsed time
                                // in those two cases — same convention RejectAgoraCall already used
                                // for "Rejected" server-side. Direction-aware, WhatsApp-style: the
                                // caller sees "No answer", the callee sees "Missed call from X".
                                if (msg.callDuration === "Missed" && (msg as any).pstnDialSuccess) {
                                  // PSTN fallback (BonVoice) was dialed for this call — deliberately
                                  // NOT "Connected via phone": BonVoice's autoCallBridging is fire-
                                  // and-forget with no confirmed webhook/CDR, so the backend only
                                  // knows the phone was dialed, never whether anyone answered.
                                  callTitleText = `📞 Tried calling your phone (${displayCallerName} ↔ ${displayReceiverName})`;
                                } else if (msg.callDuration === "Missed") {
                                  callTitleText = isSender
                                    ? `📵 No answer (${displayCallerName} ➔ ${displayReceiverName})`
                                    : `📵 Missed call from ${displayCallerName}`;
                                } else if (msg.callDuration === "Rejected") {
                                  callTitleText = `📵 Call declined (${displayCallerName} ↔ ${displayReceiverName})`;
                                } else if (msg.callDuration === "Cancelled") {
                                  callTitleText = `📞 Call cancelled (${displayCallerName} ↔ ${displayReceiverName})`;
                                } else {
                                  callTitleText = `📞 Call ended (${displayCallerName} ↔ ${displayReceiverName}). Duration: ${msg.callDuration || "Closed"}`;
                                }
                              } else if (isGroupCallMsg) {
                                callTitleText = `📞 Group Conference Call started. Click to join.`;
                              } else if (isSender) {
                                callTitleText = `📞 Calling ${displayReceiverName}... (${displayCallerName} ➔ ${displayReceiverName})`;
                              } else if (isTargeted && !isCallFull) {
                                callTitleText = `📞 Incoming 1-to-1 Call: ${displayCallerName} ➔ ${displayReceiverName}`;
                              } else if (!isTargeted) {
                                callTitleText = `🔒 Private 1-to-1 Call in Progress (${displayCallerName} ↔ ${displayReceiverName})`;
                              } else {
                                callTitleText = `🔒 Call in Progress: ${displayCallerName} ↔ ${displayReceiverName} (${activeCount}/2 Participants)`;
                              }

                              const showAcceptButton = !isSender && isTargeted && !isCallFull;

                              return (
                                <Box sx={{ p: 2 }}>
                                  <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 'bold', color: msg.senderUserId === myInfo.id ? "white" : "text.primary" }}>
                                    {callTitleText}
                                  </Typography>
                                  {!msg.isCallEnded ? (
                                    (agoraCallData.open && Number(agoraCallData.messageId) === Number(msg.pkChatMessage)) ? (
                                      <Typography variant="caption" sx={{ color: msg.senderUserId === myInfo.id ? "rgba(255,255,255,0.9)" : "#10b981", fontWeight: 'bold', display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                        <span style={{ animation: 'pulse 1.5s infinite' }}>●</span> Call in Progress
                                      </Typography>
                                    ) : showAcceptButton ? (
                                      <Stack direction="row" spacing={1} mt={1}>
                                        <Button
                                          variant="contained"
                                          size="small"
                                          startIcon={msg.messageContent?.includes("Video") || msg.messageContent?.includes("📹") ? <Videocam /> : <Call />}
                                          onClick={() => handleCallConnection(true, msg.messageContent?.includes("Video") || msg.messageContent?.includes("📹") || false)}
                                          sx={{
                                            borderRadius: 20,
                                            backgroundColor: "#10b981",
                                            color: "#fff",
                                            "&:hover": { backgroundColor: "#059669" }
                                          }}
                                        >
                                          Accept / Join Call
                                        </Button>
                                        <Button
                                          variant="outlined"
                                          size="small"
                                          color="error"
                                          onClick={() => handleDeclineCall(msg.pkChatMessage?.toString() || "", false)}
                                          sx={{
                                            borderRadius: 20,
                                            backgroundColor: "rgba(255,255,255,0.9)",
                                            "&:hover": { backgroundColor: "#fff" }
                                          }}
                                        >
                                          Decline
                                        </Button>
                                      </Stack>
                                    ) : isSender ? (
                                      <Stack direction="row" spacing={1} mt={1}>
                                        <Button
                                          variant="outlined"
                                          size="small"
                                          color="error"
                                          onClick={() => handleDeclineCall(msg.pkChatMessage?.toString() || "", true)}
                                          sx={{
                                            borderRadius: 20,
                                            backgroundColor: "rgba(255,255,255,0.9)",
                                            "&:hover": { backgroundColor: "#fff" }
                                          }}
                                        >
                                          Cancel Call
                                        </Button>
                                      </Stack>
                                    ) : (
                                      <Box sx={{ mt: 1, p: 1, borderRadius: 2, bgcolor: msg.senderUserId === myInfo.id ? "rgba(255,255,255,0.15)" : "rgba(0,0,0,0.04)", display: 'flex', alignItems: 'center', gap: 1 }}>
                                        <Typography variant="caption" sx={{ fontWeight: 'bold', color: msg.senderUserId === myInfo.id ? "#fff" : "text.secondary", display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                          🔒 Private 1-to-1 Call in Progress
                                        </Typography>
                                      </Box>
                                    )
                                  ) : (
                                    <Typography variant="caption" sx={{ color: msg.senderUserId === myInfo.id ? "rgba(255,255,255,0.7)" : "text.secondary" }}>Session Closed</Typography>
                                  )}
                                </Box>
                              );
                            })() :
                              (msg.messageType?.startsWith("file") ||
                                msg.messageType?.startsWith("image") ||
                                msg.messageType?.startsWith("photo") ||
                                msg.messageType?.startsWith("media") ||
                                // A backend bug can populate attachmentUrl with a bogus, non-file
                                // value (e.g. the SOS broadcast's attachmentUrl is literally the
                                // API route "/chat/{caseId}/messages") on an otherwise plain text
                                // message. Only fall back to attachment rendering off a bare
                                // attachmentUrl when there's no real text to show instead — see
                                // the equivalent fix in the mobile app's SingleChatScreen.tsx.
                                (Boolean(msg.attachmentUrl) && !Boolean(msg.messageContent && String(msg.messageContent).trim()))) ? (
                                // SuperAdmin is exempt from this restriction — only plain Admin has
                                // attachments hidden. Do not widen this back to include SUPERADMIN.
                                // E_MITRA_USER (2026-09-03): e-mitra agents can now see/participate
                                // in the chat for cases they created on behalf of a client, but same
                                // as Admin they must not see attachment content — only that
                                // something was sent.
                                (myInfo?.userType === "ADMIN" || myInfo?.userType?.toUpperCase() === "E_MITRA_USER") && msg.senderUserId !== myInfo.id
                                  && !(selectedCase?.orderType === "Admin Support" || selectedCase?.orderTypeId === 53) ? (
                                  <Typography
                                    variant="body2"
                                    component="span"
                                    sx={{
                                      fontStyle: "italic",
                                      color: "text.secondary",
                                      display: "flex",
                                      alignItems: "center",
                                      gap: 0.5,
                                      fontWeight: 500,
                                      py: 0.5
                                    }}
                                  >
                                    🔒 Attachment hidden
                                  </Typography>
                                ) : (
                                  <AttachmentComponent message={msg} downloadImage={downloadImage} setSelectedDocument={({ attachmentUrl, docType }) =>
                                    setSelectedDocument({
                                      url: attachmentUrl,
                                      docType: docType,
                                    })} />
                                )
                              ) :
                                <Typography
                                  variant="body2"
                                  component="span"
                                  sx={{
                                    wordBreak: "break-word",
                                    overflowWrap: "break-word",
                                    color: msg.senderUserId === myInfo.id ? "white" : "black",
                                    whiteSpace: "pre-wrap",
                                    fontWeight: 500,
                                    lineHeight: 1.5,
                                    display: "block",
                                  }}
                                >
                                  {parseMessageWithLinks(msg.messageContent ?? "").map((seg, si) => {
                                    if (seg.type === "link") {
                                      return (
                                        <a
                                          key={si}
                                          href={seg.content}
                                          target="_blank"
                                          rel="noopener noreferrer"
                                          style={{
                                            color: msg.senderUserId === myInfo.id ? "#b3d4ff" : "#1a237e",
                                            textDecoration: "underline",
                                            wordBreak: "break-all",
                                            fontWeight: 600,
                                          }}
                                        >
                                          {seg.content}
                                        </a>
                                      );
                                    }
                                    if (seg.type === "blocked") {
                                      return (
                                        <Tooltip key={si} title={`Blocked URL: ${seg.rawUrl}`} arrow>
                                          <span style={{
                                            color: "#ef4444",
                                            fontWeight: 700,
                                            fontSize: "0.78em",
                                            background: "rgba(239,68,68,0.1)",
                                            borderRadius: 4,
                                            padding: "1px 6px",
                                            cursor: "not-allowed",
                                          }}>
                                            🔒 {seg.content}
                                          </span>
                                        </Tooltip>
                                      );
                                    }
                                    return <React.Fragment key={si}>{seg.content}</React.Fragment>;
                                  })}
                                </Typography>
                          }
                        </>
                      )}

                      {/* WhatsApp Style Time, Date & Read Receipt Ticks (Inside Bubble) */}
                      <Box sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "flex-end",
                        gap: 0.5,
                        mt: 0.75,
                        alignSelf: "flex-end",
                      }}>
                        <Typography
                          variant="caption"
                          sx={{
                            fontSize: "0.65rem",
                            fontWeight: 600,
                            color: (isMe && !isPayment) ? "rgba(255, 255, 255, 0.75)" : "text.secondary",
                          }}
                        >
                          {parseISTDate(msg.timestamp).format("hh:mm A, DD-MM-YYYY")}
                        </Typography>

                        {isMe && (
                          isRead ? (
                            <DoneAll sx={{ fontSize: 16, color: "#38bdf8", ml: 0.2 }} />
                          ) : isDelivered ? (
                            <DoneAll sx={{ fontSize: 16, color: "rgba(255, 255, 255, 0.7)", ml: 0.2 }} />
                          ) : (
                            <Done sx={{ fontSize: 16, color: "rgba(255, 255, 255, 0.7)", ml: 0.2 }} />
                          )
                        )}

                        {!msg.isDeleted && ((isMe && isWithin15Mins(msg.timestamp)) || myInfo?.userType === "ADMIN" || myInfo?.userType === "SUPERADMIN") && (msg.pkChatMessage || msg.id) && (
                          <Tooltip title="Delete message">
                            <IconButton
                              size="small"
                              onClick={() => setDeleteTarget({ id: Number(msg.pkChatMessage || msg.id), timestamp: msg.timestamp })}
                              sx={{ p: 0.2, ml: 0.5, color: (isMe && !isPayment) ? "#fca5a5" : "#ef4444", opacity: 0.8, "&:hover": { opacity: 1, backgroundColor: "rgba(239, 68, 68, 0.15)" } }}
                            >
                              <DeleteForeverRounded sx={{ fontSize: 14 }} />
                            </IconButton>
                          </Tooltip>
                        )}
                      </Box>
                    </Box>
                  </Box>
                </React.Fragment>
              );
            })
          ) : <Box sx={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}><NoData cstmMsg="Your conversation will appear here." /></Box>;
        })()}

        {/* Spacer for Mobile Fixed Input */}
        <Box sx={{ height: "10px", flexShrink: 0 }} />
      </Box>

      {/* RECORDING PREVIEW */}
      {isRecording && (
        <Box sx={{ p: 1, backgroundColor: "#fff", borderTop: "1px solid #ccc" }}>
          <canvas ref={canvasRef} width={300} height={40} style={{ margin: "0 auto", display: "block" }} />
        </Box>
      )}

      {recordedAudioUrl && (
        <Box sx={{ display: "flex", alignItems: "center", p: 1, backgroundColor: "#fff", borderTop: "1px solid #ccc" }}>
          <audio controls src={recordedAudioUrl} style={{ height: 30, flex: 1 }} />
          <IconButton onClick={handleDeleteRecording} color="error"><DeleteForeverRounded /></IconButton>
        </Box>
      )}

      {/* ODR Professional Case Status Update Bar */}
      {isNeutral && isOdrCase && (
        <Box sx={{
          px: 3,
          pt: 1.5,
          pb: 0.5,
          backgroundColor: "rgba(240, 247, 255, 0.9)",
          backdropFilter: "blur(10px)",
          borderTop: "1px solid rgba(40, 49, 101, 0.1)",
          position: "relative",
          zIndex: 11,
        }}>
          <Box sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
            p: 0.75,
            backgroundColor: "rgba(40, 49, 101, 0.04)",
            borderRadius: "16px",
            border: "1px dashed rgba(40, 49, 101, 0.25)",
          }}>
            <Box sx={{
              width: 6,
              height: 6,
              borderRadius: "50%",
              bgcolor: "#10b981",
              flexShrink: 0,
              boxShadow: "0 0 0 3px rgba(16,185,129,0.2)"
            }} />
            <InputBase
              value={odrStatusInput}
              onChange={(e) => setOdrStatusInput(e.target.value)}
              onKeyDown={(e) => { if (e.key === "Enter" && !e.shiftKey) { e.preventDefault(); handleOdrProfessionalStatusUpdate(); } }}
              placeholder="Post a custom ODR case status (visible everywhere)..."
              sx={{
                flex: 1,
                fontSize: "13px",
                fontWeight: 500,
                color: "#283165",
                fontFamily: "Inter",
                "& input::placeholder": { color: "#94a3b8" }
              }}
            />
            <Button
              size="small"
              variant="contained"
              disabled={!odrStatusInput.trim() || odrStatusSubmitting}
              onClick={handleOdrProfessionalStatusUpdate}
              sx={{
                bgcolor: "#283165",
                color: "#fff",
                borderRadius: "10px",
                textTransform: "none",
                fontWeight: 600,
                fontSize: "12px",
                px: 2,
                py: 0.5,
                flexShrink: 0,
                "&:hover": { bgcolor: "#1c234b" },
                "&:disabled": { bgcolor: "#e2e8f0", color: "#94a3b8" }
              }}
            >
              {odrStatusSubmitting ? "Updating..." : "Update Status"}
            </Button>
          </Box>
        </Box>
      )}

      {/* VERSION 4: CLEAN WHITE PILL INPUT ISLAND */}
      <Box sx={{
        px: { xs: 1.5, sm: 2, md: 3 },
        py: { xs: 1, sm: 1.5, md: 2 },
        backgroundColor: "rgba(240, 247, 255, 0.8)", // Lightweight Azure tint
        backdropFilter: "blur(10px)",
        borderTop: "1px solid rgba(0,0,0,0.04)",
        position: "relative",
        zIndex: 12,
        flexShrink: 0,
        pb: { xs: 1, sm: 1.5, md: "env(safe-area-inset-bottom, 20px)" }
      }}>
        {/* Floating WhatsApp-Style Typing Banner Above Input Box */}
        {isParticipantTyping && (
          <Box sx={{
            px: 2,
            py: 0.5,
            mb: 1,
            display: "flex",
            alignItems: "center",
            gap: 1,
            bgcolor: "rgba(37, 211, 102, 0.12)",
            borderRadius: "12px",
            width: "fit-content",
            border: "1px solid rgba(37, 211, 102, 0.3)"
          }}>
            <Typography variant="caption" sx={{ color: "#128C7E", fontWeight: 700, fontStyle: "italic" }}>
              ✍️ {typingUserName || "Participant"} is typing...
            </Typography>
          </Box>
        )}
        <Paper elevation={0} sx={{
          display: "flex",
          alignItems: "flex-end",
          p: 0.75,
          backgroundColor: "#fff",
          borderRadius: "24px",
          border: "1px solid rgba(26, 35, 126, 0.15)",
          transition: "all 0.3s ease",
          boxShadow: "0 4px 15px rgba(0,0,0,0.05)",
          "&:focus-within": {
            boxShadow: "0 8px 25px rgba(26, 35, 126, 0.12)",
            borderColor: "#1a237e",
          }
        }}>
          {isCompleted && !isAdmin ? (
            <Box sx={{ flex: 1, display: "flex", justifyContent: "center", alignItems: "center" }}>
              <Typography variant="body2" sx={{ color: "error.main", fontWeight: 500 }}>
                This case has been completed. The chat is closed for new messages.
              </Typography>
            </Box>
          ) : (
            <>
              <IconButton
                component="label"
                sx={{
                  color: "#1a237e",
                  "&:hover": { backgroundColor: alpha("#1a237e", 0.05) }
                }}
              >
                <AttachFile />
                <input
                  type="file"
                  multiple
                  hidden
                  accept=".jpg,.jpeg,.png,.gif,.heic,.heif,.webp,.pdf,.doc,.docx,.xls,.xlsx,.txt,.csv,.mp4,.webm,.mov,.mp3,.wav,.m4a"
                  onChange={handleAttachmentUpload}
                />
              </IconButton>

              <InputBase
                value={input}
                multiline
                maxRows={6}
                sx={{
                  ml: 1,
                  flex: 1,
                  fontSize: "15px",
                  fontWeight: 500,
                  py: 1,
                }}
                placeholder="Type your message..."
                onChange={(e) => {
                  setInput(e.target.value);
                  if (caseId) {
                    sendTypingStatus(Number(caseId), true);
                  }
                }}
                onKeyDown={(e) => handleEnterPress(e)}
              />

              <Stack direction="row" spacing={0.5} sx={{ mr: 0.5, mb: 0.2 }}>
                <IconButton
                  onClick={isRecording ? handleStopRecording : handleStartRecording}
                  sx={{
                    color: isRecording ? "#ff1744" : "#1a237e",
                    backgroundColor: isRecording ? alpha("#ff1744", 0.1) : "transparent",
                    "&:hover": { backgroundColor: isRecording ? alpha("#ff1744", 0.2) : alpha("#1a237e", 0.05) }
                  }}
                >
                  <Mic />
                </IconButton>

                <IconButton
                  onClick={handleSend}
                  disabled={!input.trim() && !recordedAudioUrl}
                  sx={{
                    backgroundColor: "#1a237e",
                    color: "#fff",
                    "&:hover": { backgroundColor: "#283593" },
                    "&:disabled": { backgroundColor: "#e0e0e0", color: "#9e9e9e" },
                    width: 40,
                    height: 40,
                    boxShadow: input.trim() ? "0 4px 12px rgba(26, 35, 126, 0.3)" : "none"
                  }}
                >
                  <Send sx={{ fontSize: 20, ml: 0.5 }} />
                </IconButton>
              </Stack>
            </>
          )}
        </Paper>
      </Box>

      {/* Fullscreen Previews & Payment Dialog (Keep existing logic) */}
      {/* Payment Modal */}
      <Dialog open={paymentModalOpen} onClose={() => {
        setPaymentModalOpen(false);
        setBaseAmount("");
        setAmount("");
      }}>
        <DialogTitle>Send Payment Link</DialogTitle>
        <DialogContent>
          <Typography variant="body2" sx={{ mb: 2 }}>
            Enter the base amount. The system will automatically add <strong>18% GST</strong> to calculate the total.
          </Typography>

          {isOdrCase && (
            <FormControl fullWidth margin="dense" variant="outlined" sx={{ mb: 2 }}>
              <InputLabel id="target-party-select-label">Payment Requested From</InputLabel>
              <Select
                labelId="target-party-select-label"
                value={targetParty}
                onChange={(e) => setTargetParty(e.target.value as string)}
                label="Payment Requested From"
              >
                <MenuItem value="Claimant">
                  {fullCaseData?.clientFullName || selectedCase?.clientFullName || "Claimant"} (Claimant)
                </MenuItem>
                <MenuItem value="Respondent">
                  {fullCaseData?.respondentName || fullCaseData?.respondentEmail || selectedCase?.respondentName || "Respondent"} (Respondent)
                </MenuItem>
              </Select>
            </FormControl>
          )}

          <TextField
            autoFocus
            margin="dense"
            label="Base Amount"
            type="number"
            fullWidth
            variant="outlined"
            value={baseAmount}
            onChange={(e) => {
              const val = e.target.value;
              setBaseAmount(val);
              if (val && !isNaN(Number(val))) {
                const total = (Number(val) * 1.18).toFixed(2);
                setAmount(total);
              } else {
                setAmount("");
              }
            }}
            InputProps={{
              startAdornment: <InputAdornment position="start">₹</InputAdornment>,
            }}
          />

          {baseAmount && !isNaN(Number(baseAmount)) && (
            <Box sx={{ mt: 2, p: 2, bgcolor: "#f8f9fa", borderRadius: 1, border: "1px dashed #ccc" }}>
              <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
                <Typography variant="body2">Base Amount:</Typography>
                <Typography variant="body2" fontWeight="500">₹{Number(baseAmount).toFixed(2)}</Typography>
              </Box>
              <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
                <Typography variant="body2">GST (18%):</Typography>
                <Typography variant="body2" fontWeight="500">₹{(Number(baseAmount) * 0.18).toFixed(2)}</Typography>
              </Box>
              <Box sx={{ display: "flex", justifyContent: "space-between", mt: 1, pt: 1, borderTop: "1px solid #ddd" }}>
                <Typography variant="subtitle2" fontWeight="bold">Total Amount:</Typography>
                <Typography variant="subtitle2" fontWeight="bold" color="primary.main">₹{amount}</Typography>
              </Box>
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setPaymentModalOpen(false)}>Cancel</Button>
          <Button
            onClick={handleSendPaymentLink}
            variant="contained"
            disabled={isGeneratingLink || !amount}
          >
            {isGeneratingLink ? "Generating..." : "Send Link"}
          </Button>
        </DialogActions>
      </Dialog>

      {/* E-Sign Modal */}
      <Dialog open={eSignModalOpen} onClose={() => setESignModalOpen(false)}>
        <DialogTitle>Send Document for E-Sign</DialogTitle>
        <DialogContent>
          <Typography variant="body2" sx={{ mb: 2 }}>
            Upload a PDF document to send to all parties for E-Signature.
          </Typography>
          <Button
            variant="outlined"
            component="label"
            fullWidth
            sx={{ p: 2, borderStyle: "dashed", borderRadius: 2 }}
          >
            {eSignFile ? eSignFile.name : "Upload PDF Document"}
            <input type="file" hidden accept=".pdf" onChange={(e) => setESignFile(e.target.files?.[0] || null)} />
          </Button>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setESignModalOpen(false)}>Cancel</Button>
          <Button
            onClick={handleSendForESign}
            variant="contained"
            disabled={actionLoading || !eSignFile}
          >
            {actionLoading ? "Sending..." : "Send"}
          </Button>
        </DialogActions>
      </Dialog>

      {/* E-Stamp Modal */}
      <Dialog open={eStampModalOpen} onClose={() => setEStampModalOpen(false)}>
        <DialogTitle>Send Document for E-Stamp & E-Sign</DialogTitle>
        <DialogContent>
          <Typography variant="body2" sx={{ mb: 2 }}>
            Select a state and upload a PDF document.
          </Typography>
          <FormControl fullWidth sx={{ mb: 3, mt: 1 }}>
            <InputLabel>Select State</InputLabel>
            <Select
              value={eStampState}
              label="Select State"
              onChange={(e) => setEStampState(e.target.value)}
            >
              {(Array.isArray(stampStates) ? stampStates : []).map((s) => (
                <MenuItem key={s.pkEStampDetails} value={s.stateCode}>
                  {s.stateName} - ₹{s.denomination}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <Button
            variant="outlined"
            component="label"
            fullWidth
            sx={{ p: 2, borderStyle: "dashed", borderRadius: 2 }}
          >
            {eStampFile ? eStampFile.name : "Upload PDF Document"}
            <input type="file" hidden accept=".pdf" onChange={(e) => setEStampFile(e.target.files?.[0] || null)} />
          </Button>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setEStampModalOpen(false)}>Cancel</Button>
          <Button
            onClick={handleSendForEStamp}
            variant="contained"
            disabled={actionLoading || !eStampFile || !eStampState}
          >
            {actionLoading ? "Sending..." : "Send"}
          </Button>
        </DialogActions>
      </Dialog>
      {agoraCallData.open && !globalCallData?.open && (
        <AgoraCall
          appId={agoraCallData.appId}
          channelName={agoraCallData.channelName}
          token={agoraCallData.token}
          uid={agoraCallData.uid}
          participants={agoraCallData.participants}
          onClose={() => setAgoraCallData({ ...agoraCallData, open: false })}
          onEndCall={handleEndCall}
          isVideoCall={agoraCallData.isVideoCall}
        />
      )}

      {/* Call Participant Selection Modal */}
      <Dialog open={callModalOpen} onClose={() => setCallModalOpen(false)} maxWidth="xs" fullWidth>
        <DialogTitle sx={{ bgcolor: "#1a237e", color: "#fff", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <Typography variant="h6">{callIsVideo ? "📹 Initiate Video Call" : "📞 Initiate Voice Call"}</Typography>
          <IconButton size="small" onClick={() => setCallModalOpen(false)} sx={{ color: "#fff" }}><Close /></IconButton>
        </DialogTitle>
        <DialogContent dividers>
          <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 1, color: "#334155" }}>
            Call Options:
          </Typography>
          <FormControlLabel
            control={
              <Checkbox
                checked={isGroupCall}
                onChange={(e: any) => {
                  setIsGroupCall(e.target.checked);
                  if (e.target.checked) setSelectedCallUserIds([]);
                }}
              />
            }
            label={<strong>🌐 Group Call (Ring All Members)</strong>}
          />
          {!isGroupCall && (
            <Box mt={2}>
              <Typography variant="caption" color="textSecondary" sx={{ fontWeight: 600, display: "block", mb: 1 }}>
                Select Specific Member(s) to Call:
              </Typography>
              {(() => {
                const participants = getCallParticipantsList();
                if (participants.length === 0) {
                  return (
                    <Typography variant="body2" color="textSecondary" sx={{ fontStyle: "italic", py: 1 }}>
                      No other members found in this chat.
                    </Typography>
                  );
                }
                return (
                  <Stack spacing={1}>
                    {participants.map(([uId, uName]) => (
                      <FormControlLabel
                        key={uId}
                        control={
                          <Checkbox
                            checked={selectedCallUserIds.includes(Number(uId))}
                            onChange={(e: any) => {
                              const numId = Number(uId);
                              if (e.target.checked) {
                                setSelectedCallUserIds((prev) => [...prev, numId]);
                              } else {
                                setSelectedCallUserIds((prev) => prev.filter((id) => id !== numId));
                              }
                            }}
                          />
                        }
                        label={String(uName)}
                      />
                    ))}
                  </Stack>
                );
              })()}
            </Box>
          )}
        </DialogContent>
        <DialogActions sx={{ p: 2 }}>
          <Button onClick={() => setCallModalOpen(false)} variant="outlined">Cancel</Button>
          <Button
            onClick={handleStartSelectedCall}
            variant="contained"
            color="primary"
            disabled={!isGroupCall && selectedCallUserIds.length === 0}
          >
            Start Call
          </Button>
        </DialogActions>
      </Dialog>

      {/* WHATSAPP-STYLE DELETE MESSAGE CONFIRMATION MODAL */}
      <Dialog
        open={Boolean(deleteTarget)}
        onClose={() => setDeleteTarget(null)}
        PaperProps={{
          sx: {
            borderRadius: 3,
            p: 1,
            minWidth: 320,
            maxWidth: 400,
          }
        }}
      >
        <DialogTitle sx={{ fontWeight: 700, fontSize: "1.1rem", pb: 1 }}>
          Delete message?
        </DialogTitle>
        <DialogContent>
          <Typography variant="body2" color="text.secondary">
            Delete for everyone? This message will be permanently removed for all participants.
          </Typography>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2, pt: 1, gap: 1 }}>
          <Button
            onClick={() => setDeleteTarget(null)}
            variant="outlined"
            sx={{ borderRadius: 2, textTransform: "none", color: "text.primary", borderColor: "#ccc" }}
          >
            Cancel
          </Button>
          <Button
            onClick={confirmDeleteSingleMessage}
            variant="contained"
            color="error"
            sx={{ borderRadius: 2, textTransform: "none", fontWeight: 600, boxShadow: "none" }}
          >
            Delete for everyone
          </Button>
        </DialogActions>
      </Dialog>

      {/* WHATSAPP-STYLE GROUP INFO & MEMBERS MODAL */}
      <Dialog
        open={groupInfoModalOpen}
        onClose={() => setGroupInfoModalOpen(false)}
        maxWidth="xs"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 4,
            p: 1,
            boxShadow: "0 20px 40px rgba(0,0,0,0.15)",
          }
        }}
      >
        <DialogTitle sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", pb: 1 }}>
          <Box display="flex" alignItems="center" gap={1.5}>
            <Avatar sx={{ bgcolor: "#1a237e", width: 42, height: 42, fontWeight: 800 }}>
              {getInitials(selectedCase?.orderType ?? "")}
            </Avatar>
            <Box>
              <Typography variant="subtitle1" sx={{ fontWeight: 800, color: "#1a237e", lineHeight: 1.2 }}>
                {selectedCase?.caseName || selectedCase?.orderType || "Group Info"}
              </Typography>
              <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 600 }}>
                {roomParticipants.length} Group Members
              </Typography>
            </Box>
          </Box>
          <IconButton size="small" onClick={() => setGroupInfoModalOpen(false)}>
            <Close />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers sx={{ py: 2 }}>
          <Typography variant="caption" sx={{ fontWeight: 700, color: "#64748b", textTransform: "uppercase", letterSpacing: 0.5, mb: 1.5, display: "block" }}>
            Participants in this Chat
          </Typography>
          <Stack spacing={1.5}>
            {roomParticipants.map((p: any) => {
              const isMe = Number(p.id) === Number(myInfo?.id);
              const isUserOnline = isMe ? true : (onlineUserIds.has(Number(p.id)) || Boolean(p.isOnline));
              return (
                <Box
                  key={p.id}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    p: 1.25,
                    borderRadius: 3,
                    bgcolor: isMe ? "rgba(26, 35, 126, 0.04)" : "#f8fafc",
                    border: "1px solid rgba(0,0,0,0.04)",
                  }}
                >
                  <Box display="flex" alignItems="center" gap={1.5}>
                    <Avatar sx={{ bgcolor: isMe ? "#1a237e" : "#334155", width: 38, height: 38, fontSize: "14px", fontWeight: 700 }}>
                      {getInitials(p.name)}
                    </Avatar>
                    <Box>
                      <Typography variant="body2" sx={{ fontWeight: 700, color: "#1e293b", display: "flex", alignItems: "center", gap: 0.5 }}>
                        {p.name} {isMe && "(You)"}
                      </Typography>
                      <Typography variant="caption" sx={{ color: "#64748b", fontWeight: 600 }}>
                        {p.role || p.userType || "Participant"}
                      </Typography>
                    </Box>
                  </Box>
                  <Chip
                    label={isUserOnline ? "Online" : "Offline"}
                    size="small"
                    sx={{
                      height: 22,
                      fontSize: "11px",
                      fontWeight: 700,
                      bgcolor: isUserOnline ? "rgba(37, 211, 102, 0.15)" : "rgba(100, 116, 139, 0.1)",
                      color: isUserOnline ? "#128C7E" : "#64748b",
                      border: isUserOnline ? "1px solid rgba(37, 211, 102, 0.3)" : "none",
                    }}
                  />
                </Box>
              );
            })}
          </Stack>
        </DialogContent>
        <DialogActions sx={{ p: 2, justifyContent: "center" }}>
          <Button onClick={() => setGroupInfoModalOpen(false)} variant="contained" sx={{ borderRadius: 3, bgcolor: "#1a237e", px: 4, textTransform: "none", fontWeight: 700 }}>
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default SingleChatScreen1;
const sxHead = {
  backgroundColor: "primary.main",
  px: 2,
  "& >p:first-of-type": {
    color: "white",
  },
  "& >button": {
    color: "white",
  },
};
const sxMain = {
  display: "flex",
  flexDirection: "column",
  top: "50%",
  left: "50%",
  transform: `translate(-${50}%, -${50}%)`,
  position: "absolute",
  outline: "none",
  // overflow: "auto",
  borderRadius: 1.25,
};
